import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';
import { fetchData } from 'gql/graphql-fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Decimal: any;
};

/** A segment of a collection. */
export type ActivitiesCollectionSegment = {
  __typename?: 'ActivitiesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Activity>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type ActivitiesCountByDate = {
  __typename?: 'ActivitiesCountByDate';
  activityType: ActivityType;
  count: Scalars['Int'];
  date: Scalars['DateTime'];
};

export type ActivitiesCountByType = {
  __typename?: 'ActivitiesCountByType';
  activityType: ActivityType;
  count: Scalars['Int'];
};

export type Activity = {
  __typename?: 'Activity';
  createdAt: Scalars['DateTime'];
  createdBy: ApplicationUser;
  createdById: Scalars['String'];
  customFieldValues: Array<CustomFieldValue>;
  distributions: Array<DistributionValue>;
  id: Scalars['Int'];
  individuals: Array<Individual>;
  isDeleted: Scalars['Boolean'];
  owningTeamId: Scalars['Int'];
  realities: Array<Reality>;
  type: ActivityType;
  unknownGroups: Array<UnknownGroup>;
};


export type ActivityCustomFieldValuesArgs = {
  where?: InputMaybe<CustomFieldValueFilterInput>;
};


export type ActivityIndividualsArgs = {
  where?: InputMaybe<IndividualFilterInput>;
};


export type ActivityRealitiesArgs = {
  where?: InputMaybe<RealityFilterInput>;
};


export type ActivityUnknownGroupsArgs = {
  where?: InputMaybe<UnknownGroupFilterInput>;
};

export type ActivityAdded = {
  __typename?: 'ActivityAdded';
  activityId: Scalars['Int'];
};

export type ActivityFilterInput = {
  and?: InputMaybe<Array<ActivityFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<ApplicationUserFilterInput>;
  customFieldValues?: InputMaybe<ListFilterInputTypeOfCustomFieldValueFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  individuals?: InputMaybe<ListFilterInputTypeOfIndividualFilterInput>;
  interventionDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ActivityFilterInput>>;
  owningTeamId?: InputMaybe<IntOperationFilterInput>;
  realities?: InputMaybe<ListFilterInputTypeOfRealityFilterInput>;
  type?: InputMaybe<ActivityTypeOperationFilterInput>;
};

export type ActivityIndividualInput = {
  edited: Scalars['Boolean'];
  id?: InputMaybe<Scalars['Int']>;
  values: Array<FieldValueInput>;
};

export enum ActivityType {
  Distribution = 'Distribution',
  Intervention = 'Intervention',
  Meeting = 'Meeting',
  Presentation = 'Presentation',
  Routine = 'Routine'
}

export type ActivityTypeOperationFilterInput = {
  eq?: InputMaybe<ActivityType>;
  in?: InputMaybe<Array<ActivityType>>;
  neq?: InputMaybe<ActivityType>;
  nin?: InputMaybe<Array<ActivityType>>;
};

export type ActivityUpdated = {
  __typename?: 'ActivityUpdated';
  activityId: Scalars['Int'];
};

export type AddActivityError = NotFoundError | ValidationResultError;

export type AddActivityInput = {
  distributions: Array<DistributionValueInput>;
  individuals: Array<ActivityIndividualInput>;
  realities: Array<RealityInput>;
  type: ActivityType;
  unknownGroups: Array<UnknownGroupInput>;
  values: Array<FieldValueInput>;
};

export type AddActivityPayload = {
  __typename?: 'AddActivityPayload';
  activity?: Maybe<Activity>;
  errors?: Maybe<Array<AddActivityError>>;
};

export type AddCustomPropertyError = DuplicateNameError | ValidationResultError;

export type AddCustomPropertyInput = {
  allowMultipleValues: Scalars['Boolean'];
  customOptions?: InputMaybe<Array<CustomOptionInput>>;
  entityType: EntityType;
  fieldType: CustomFieldType;
  isRequired: Scalars['Boolean'];
  numberOfLines: Scalars['Int'];
  propertyDescription: Scalars['String'];
  propertyName: Scalars['String'];
  sectionId: Scalars['Int'];
  status: CustomFieldStatusType;
};

export type AddCustomPropertyPayload = {
  __typename?: 'AddCustomPropertyPayload';
  customField?: Maybe<CustomField>;
  errors?: Maybe<Array<AddCustomPropertyError>>;
};

export type AddDistributionCategoryError = ValidationResultError;

export type AddDistributionCategoryInput = {
  name: Scalars['String'];
};

export type AddDistributionCategoryPayload = {
  __typename?: 'AddDistributionCategoryPayload';
  errors?: Maybe<Array<AddDistributionCategoryError>>;
  int?: Maybe<Scalars['Int']>;
};

export type AddDistributionItemError = ValidationResultError;

export type AddDistributionItemInput = {
  categoryIds: Array<Scalars['Int']>;
  description: Scalars['String'];
  name: Scalars['String'];
  unit: Scalars['String'];
};

export type AddDistributionItemPayload = {
  __typename?: 'AddDistributionItemPayload';
  errors?: Maybe<Array<AddDistributionItemError>>;
  int?: Maybe<Scalars['Int']>;
};

export type AddFieldToEntityTypeError = ValidationResultError;

export type AddFieldToEntityTypeInput = {
  customFieldId: Scalars['Int'];
  entityType: EntityType;
  sectionId: Scalars['Int'];
};

export type AddFieldToEntityTypePayload = {
  __typename?: 'AddFieldToEntityTypePayload';
  customField?: Maybe<CustomField>;
  errors?: Maybe<Array<AddFieldToEntityTypeError>>;
};

export type AddIndividualError = ValidationResultError;

export type AddIndividualInput = {
  values: Array<FieldValueInput>;
};

export type AddIndividualPayload = {
  __typename?: 'AddIndividualPayload';
  errors?: Maybe<Array<AddIndividualError>>;
  individual?: Maybe<Individual>;
};

export type AddReportModelError = ValidationResultError;

export type AddReportModelInput = {
  filterValues: ReportParametersInput;
  name: Scalars['String'];
};

export type AddReportModelPayload = {
  __typename?: 'AddReportModelPayload';
  errors?: Maybe<Array<AddReportModelError>>;
  report?: Maybe<Report>;
};

export type AddSectionError = DuplicateNameError | ValidationResultError;

export type AddSectionInput = {
  entityType: EntityType;
  name: Scalars['String'];
};

export type AddSectionPayload = {
  __typename?: 'AddSectionPayload';
  customFieldSection?: Maybe<CustomFieldSection>;
  errors?: Maybe<Array<AddSectionError>>;
};

export type AddTeamError = DuplicateNameError | ValidationResultError;

export type AddTeamInput = {
  description: Scalars['String'];
  name: Scalars['String'];
};

export type AddTeamMembersError = NotFoundError | ValidationResultError;

export type AddTeamMembersInput = {
  members: Array<Scalars['String']>;
  teamId: Scalars['Int'];
};

export type AddTeamMembersPayload = {
  __typename?: 'AddTeamMembersPayload';
  errors?: Maybe<Array<AddTeamMembersError>>;
  team?: Maybe<Team>;
};

export type AddTeamPayload = {
  __typename?: 'AddTeamPayload';
  errors?: Maybe<Array<AddTeamError>>;
  team?: Maybe<Team>;
};

export type AddTenantError = DuplicateNameError | MissingConfigurationError | ValidationResultError;

export type AddTenantInput = {
  adminInput: AddTenantUserInput;
  tenantInput: TenantInput;
};

export type AddTenantPayload = {
  __typename?: 'AddTenantPayload';
  errors?: Maybe<Array<AddTenantError>>;
  tenant?: Maybe<Tenant>;
};

export type AddTenantUserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  preferredCommunicationLanguage?: InputMaybe<Scalars['String']>;
  teamIds: Array<Scalars['Int']>;
};

export type ApplicationRole = {
  __typename?: 'ApplicationRole';
  name: Scalars['String'];
  normalizedName: Scalars['String'];
};

export type ApplicationRoleFilterInput = {
  and?: InputMaybe<Array<ApplicationRoleFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ApplicationRoleFilterInput>>;
};

export type ApplicationUser = {
  __typename?: 'ApplicationUser';
  displayName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['String'];
  lastName: Scalars['String'];
  roles: Array<ApplicationRole>;
  status: UserStatusType;
  teams: Array<Team>;
};

export type ApplicationUserFilterInput = {
  and?: InputMaybe<Array<ApplicationUserFilterInput>>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ApplicationUserFilterInput>>;
  roles?: InputMaybe<ListFilterInputTypeOfApplicationRoleFilterInput>;
  status?: InputMaybe<UserStatusTypeOperationFilterInput>;
  teams?: InputMaybe<ListFilterInputTypeOfTeamFilterInput>;
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER',
  Validation = 'VALIDATION'
}

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
  neq?: InputMaybe<Scalars['Boolean']>;
};

export enum BuiltInRoles {
  Analyst = 'Analyst',
  GlobalAdministrator = 'GlobalAdministrator',
  StreetOutreachWorker = 'StreetOutreachWorker',
  TenantAdministrator = 'TenantAdministrator'
}

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  __typename?: 'CollectionSegmentInfo';
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
};

export type CustomField = {
  __typename?: 'CustomField';
  fieldType: CustomFieldType;
  id: Scalars['Int'];
  systemFieldId?: Maybe<SystemFieldId>;
};

export type CustomFieldDto = {
  __typename?: 'CustomFieldDto';
  allowMultipleValues: Scalars['Boolean'];
  customFieldType: CustomFieldType;
  description?: Maybe<Scalars['String']>;
  entityTypes: Array<CustomFieldEntityType>;
  id: Scalars['Int'];
  isRequired: Scalars['Boolean'];
  isSystemField: Scalars['Boolean'];
  name: Scalars['String'];
  numberOfLines: Scalars['Int'];
  options: Array<CustomFieldOptionDto>;
  status: CustomFieldStatusType;
  systemFieldId?: Maybe<SystemFieldId>;
};

export type CustomFieldDtoFilterInput = {
  allowMultipleValues?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CustomFieldDtoFilterInput>>;
  customFieldType?: InputMaybe<CustomFieldTypeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  entityTypes?: InputMaybe<ListFilterInputTypeOfCustomFieldEntityTypeFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isRequired?: InputMaybe<BooleanOperationFilterInput>;
  isSystemField?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  numberOfLines?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CustomFieldDtoFilterInput>>;
  status?: InputMaybe<CustomFieldStatusTypeOperationFilterInput>;
  systemFieldId?: InputMaybe<NullableOfSystemFieldIdOperationFilterInput>;
};

export type CustomFieldEntityType = {
  __typename?: 'CustomFieldEntityType';
  customFieldDto: CustomFieldDto;
  customFieldId: Scalars['Int'];
  entityType: EntityType;
  id: Scalars['Int'];
  order: Scalars['Int'];
  sectionId: Scalars['Int'];
};

export type CustomFieldEntityTypeFilterInput = {
  and?: InputMaybe<Array<CustomFieldEntityTypeFilterInput>>;
  entityType?: InputMaybe<EntityTypeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CustomFieldEntityTypeFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  sectionId?: InputMaybe<IntOperationFilterInput>;
};

export type CustomFieldEntityTypeSortInput = {
  order?: InputMaybe<SortEnumType>;
};

export type CustomFieldFilterInput = {
  allowMultipleValues?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CustomFieldFilterInput>>;
  entityTypes?: InputMaybe<ListFilterInputTypeOfCustomFieldEntityTypeFilterInput>;
  fieldType?: InputMaybe<CustomFieldTypeOperationFilterInput>;
  i18n?: InputMaybe<ListFilterInputTypeOfCustomFieldI18nFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  isRequired?: InputMaybe<BooleanOperationFilterInput>;
  isSystemField?: InputMaybe<BooleanOperationFilterInput>;
  numberOfLines?: InputMaybe<IntOperationFilterInput>;
  options?: InputMaybe<ListFilterInputTypeOfCustomFieldOptionFilterInput>;
  or?: InputMaybe<Array<CustomFieldFilterInput>>;
  status?: InputMaybe<CustomFieldStatusTypeOperationFilterInput>;
  systemFieldId?: InputMaybe<NullableOfSystemFieldIdOperationFilterInput>;
  values?: InputMaybe<ListFilterInputTypeOfCustomFieldValueFilterInput>;
};

export type CustomFieldI18nFilterInput = {
  and?: InputMaybe<Array<CustomFieldI18nFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  field?: InputMaybe<CustomFieldFilterInput>;
  fieldId?: InputMaybe<IntOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  language?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomFieldI18nFilterInput>>;
};

export type CustomFieldOption = {
  __typename?: 'CustomFieldOption';
  customField: CustomField;
  customFieldId: Scalars['Int'];
  i18n: Array<CustomFieldOptionI18n>;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  isSystemOption: Scalars['Boolean'];
  order: Scalars['Int'];
  values: Array<CustomFieldValue>;
};

export type CustomFieldOptionDto = {
  __typename?: 'CustomFieldOptionDto';
  customField?: Maybe<CustomField>;
  customFieldId: Scalars['Int'];
  id: Scalars['Int'];
  isSystemOption: Scalars['Boolean'];
  name: Scalars['String'];
  order: Scalars['Int'];
};

export type CustomFieldOptionDtoFilterInput = {
  and?: InputMaybe<Array<CustomFieldOptionDtoFilterInput>>;
  customField?: InputMaybe<CustomFieldFilterInput>;
  customFieldId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomFieldOptionDtoFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
};

export type CustomFieldOptionDtoSortInput = {
  customField?: InputMaybe<CustomFieldSortInput>;
  customFieldId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isSystemOption?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  order?: InputMaybe<SortEnumType>;
};

export type CustomFieldOptionFilterInput = {
  and?: InputMaybe<Array<CustomFieldOptionFilterInput>>;
  customField?: InputMaybe<CustomFieldFilterInput>;
  customFieldId?: InputMaybe<IntOperationFilterInput>;
  i18n?: InputMaybe<ListFilterInputTypeOfCustomFieldOptionI18nFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  isSystemOption?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<CustomFieldOptionFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  values?: InputMaybe<ListFilterInputTypeOfCustomFieldValueFilterInput>;
};

export type CustomFieldOptionI18n = {
  __typename?: 'CustomFieldOptionI18n';
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  language: Scalars['String'];
  name: Scalars['String'];
  option: CustomFieldOption;
  optionId: Scalars['Int'];
};

export type CustomFieldOptionI18nFilterInput = {
  and?: InputMaybe<Array<CustomFieldOptionI18nFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  language?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  option?: InputMaybe<CustomFieldOptionFilterInput>;
  optionId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CustomFieldOptionI18nFilterInput>>;
};

export type CustomFieldSection = {
  __typename?: 'CustomFieldSection';
  entityType: EntityType;
  fieldEntityTypes: Array<CustomFieldEntityType>;
  i18N: Array<CustomFieldSectionI18N>;
  id: Scalars['Int'];
  order: Scalars['Int'];
};

export type CustomFieldSectionI18N = {
  __typename?: 'CustomFieldSectionI18N';
  fieldSection: CustomFieldSection;
  fieldSectionId: Scalars['Int'];
  language: Scalars['String'];
  name: Scalars['String'];
};

export type CustomFieldSortInput = {
  allowMultipleValues?: InputMaybe<SortEnumType>;
  fieldType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  isRequired?: InputMaybe<SortEnumType>;
  isSystemField?: InputMaybe<SortEnumType>;
  numberOfLines?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  systemFieldId?: InputMaybe<SortEnumType>;
};

export enum CustomFieldStatusType {
  Active = 'Active',
  Inactive = 'Inactive'
}

export type CustomFieldStatusTypeOperationFilterInput = {
  eq?: InputMaybe<CustomFieldStatusType>;
  in?: InputMaybe<Array<CustomFieldStatusType>>;
  neq?: InputMaybe<CustomFieldStatusType>;
  nin?: InputMaybe<Array<CustomFieldStatusType>>;
};

export enum CustomFieldType {
  Date = 'Date',
  Lookup = 'Lookup',
  Numerical = 'Numerical',
  Selection = 'Selection',
  String = 'String'
}

export type CustomFieldTypeOperationFilterInput = {
  eq?: InputMaybe<CustomFieldType>;
  in?: InputMaybe<Array<CustomFieldType>>;
  neq?: InputMaybe<CustomFieldType>;
  nin?: InputMaybe<Array<CustomFieldType>>;
};

export type CustomFieldValue = {
  __typename?: 'CustomFieldValue';
  dateValue?: Maybe<Scalars['DateTime']>;
  /** SelectionValues, LookupTeamValue, and LookupUserValues needs to be included in the query to use this field. */
  displayString: Scalars['String'];
  field: CustomField;
  fieldId: Scalars['Int'];
  id: Scalars['Int'];
  lookupTeamValue?: Maybe<Team>;
  lookupUserValues: Array<ApplicationUser>;
  numericalValue?: Maybe<Scalars['Decimal']>;
  selectionValues: Array<CustomFieldOption>;
  stringValue?: Maybe<Scalars['String']>;
};

export type CustomFieldValueFilterInput = {
  and?: InputMaybe<Array<CustomFieldValueFilterInput>>;
  dateValue?: InputMaybe<DateTimeOperationFilterInput>;
  field?: InputMaybe<CustomFieldFilterInput>;
  fieldId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  lookupTeamValue?: InputMaybe<TeamFilterInput>;
  lookupUserValues?: InputMaybe<ListFilterInputTypeOfApplicationUserFilterInput>;
  numericalValue?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<CustomFieldValueFilterInput>>;
  selectionValues?: InputMaybe<ListFilterInputTypeOfCustomFieldOptionFilterInput>;
  stringValue?: InputMaybe<StringOperationFilterInput>;
};

export type CustomOptionInput = {
  customFieldId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  order: Scalars['Int'];
};

export type DateFilter = {
  __typename?: 'DateFilter';
  from?: Maybe<Scalars['DateTime']>;
  to?: Maybe<Scalars['DateTime']>;
};

export type DateFilterInput = {
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  ngt?: InputMaybe<Scalars['DateTime']>;
  ngte?: InputMaybe<Scalars['DateTime']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  nlt?: InputMaybe<Scalars['DateTime']>;
  nlte?: InputMaybe<Scalars['DateTime']>;
};

export type DeactivateUserError = NotFoundError | ValidationResultError;

export type DeactivateUserInput = {
  id: Scalars['String'];
};

export type DeactivateUserPayload = {
  __typename?: 'DeactivateUserPayload';
  errors?: Maybe<Array<DeactivateUserError>>;
  string?: Maybe<Scalars['String']>;
};

export type DecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  neq?: InputMaybe<Scalars['Decimal']>;
  ngt?: InputMaybe<Scalars['Decimal']>;
  ngte?: InputMaybe<Scalars['Decimal']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  nlt?: InputMaybe<Scalars['Decimal']>;
  nlte?: InputMaybe<Scalars['Decimal']>;
};

export type DeleteActivityError = NotFoundError | ValidationResultError;

export type DeleteActivityInput = {
  id: Scalars['Int'];
};

export type DeleteActivityPayload = {
  __typename?: 'DeleteActivityPayload';
  activity?: Maybe<Activity>;
  errors?: Maybe<Array<DeleteActivityError>>;
};

export type DeleteCustomFieldError = NotFoundError | ValidationResultError;

export type DeleteCustomFieldInput = {
  entityType: EntityType;
  id: Scalars['Int'];
};

export type DeleteCustomFieldPayload = {
  __typename?: 'DeleteCustomFieldPayload';
  customField?: Maybe<CustomField>;
  errors?: Maybe<Array<DeleteCustomFieldError>>;
};

export type DeleteDistributionCategoryError = NotFoundError;

export type DeleteDistributionCategoryInput = {
  id: Scalars['Int'];
};

export type DeleteDistributionCategoryPayload = {
  __typename?: 'DeleteDistributionCategoryPayload';
  distributionCategory?: Maybe<DistributionCategory>;
  errors?: Maybe<Array<DeleteDistributionCategoryError>>;
};

export type DeleteDistributionItemError = NotFoundError;

export type DeleteDistributionItemInput = {
  id: Scalars['Int'];
};

export type DeleteDistributionItemPayload = {
  __typename?: 'DeleteDistributionItemPayload';
  distributionItem?: Maybe<DistributionItem>;
  errors?: Maybe<Array<DeleteDistributionItemError>>;
};

export type DeleteIndividualError = NotFoundError | ValidationResultError;

export type DeleteIndividualInput = {
  id: Scalars['Int'];
};

export type DeleteIndividualPayload = {
  __typename?: 'DeleteIndividualPayload';
  errors?: Maybe<Array<DeleteIndividualError>>;
  individual?: Maybe<Individual>;
};

export type DeleteReportModelError = NotFoundError | ValidationResultError;

export type DeleteReportModelInput = {
  id: Scalars['Int'];
};

export type DeleteReportModelPayload = {
  __typename?: 'DeleteReportModelPayload';
  errors?: Maybe<Array<DeleteReportModelError>>;
  report?: Maybe<Report>;
};

export type DeleteSectionError = NotFoundError | ValidationError;

export type DeleteSectionInput = {
  id: Scalars['Int'];
};

export type DeleteSectionPayload = {
  __typename?: 'DeleteSectionPayload';
  customFieldSection?: Maybe<CustomFieldSection>;
  errors?: Maybe<Array<DeleteSectionError>>;
};

export type DeleteTeamError = NotFoundError;

export type DeleteTeamInput = {
  id: Scalars['Int'];
};

export type DeleteTeamPayload = {
  __typename?: 'DeleteTeamPayload';
  errors?: Maybe<Array<DeleteTeamError>>;
  team?: Maybe<Team>;
};

export type DistributedItems = {
  __typename?: 'DistributedItems';
  id: Scalars['Int'];
  name: Scalars['String'];
  quantity: Scalars['Int'];
};

export type DistributionCategory = {
  __typename?: 'DistributionCategory';
  i18n: Array<DistributionCategoryI18n>;
  id: Scalars['Int'];
  items: Array<DistributionItem>;
  order: Scalars['Int'];
};

export type DistributionCategoryDto = {
  __typename?: 'DistributionCategoryDto';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type DistributionCategoryDtoFilterInput = {
  and?: InputMaybe<Array<DistributionCategoryDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DistributionCategoryDtoFilterInput>>;
};

export type DistributionCategoryI18n = {
  __typename?: 'DistributionCategoryI18n';
  category: DistributionCategory;
  categoryId: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  language: Scalars['String'];
  name: Scalars['String'];
};

export type DistributionItem = {
  __typename?: 'DistributionItem';
  categories: Array<DistributionCategory>;
  i18n: Array<DistributionItemI18n>;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  isDisabled: Scalars['Boolean'];
};

export type DistributionItemDto = {
  __typename?: 'DistributionItemDto';
  categoryIds: Array<Scalars['Int']>;
  description: Scalars['String'];
  id: Scalars['Int'];
  isDisabled: Scalars['Boolean'];
  name: Scalars['String'];
  unit: Scalars['String'];
};

export type DistributionItemDtoFilterInput = {
  and?: InputMaybe<Array<DistributionItemDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  isDisabled?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DistributionItemDtoFilterInput>>;
};

export type DistributionItemI18n = {
  __typename?: 'DistributionItemI18n';
  description: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  item: DistributionItem;
  itemId: Scalars['Int'];
  language: Scalars['String'];
  name: Scalars['String'];
  unit: Scalars['String'];
};

export type DistributionValue = {
  __typename?: 'DistributionValue';
  distributedAmount: Scalars['Int'];
  itemId: Scalars['Int'];
};

export type DistributionValueInput = {
  distributedAmount: Scalars['Int'];
  itemId: Scalars['Int'];
};

export type DuplicateNameError = Error & {
  __typename?: 'DuplicateNameError';
  message: Scalars['String'];
};

export type EditActivityError = NotFoundError | ValidationResultError;

export type EditActivityInput = {
  distributions: Array<DistributionValueInput>;
  id: Scalars['Int'];
  individuals: Array<ActivityIndividualInput>;
  realities: Array<RealityInput>;
  unknownGroups: Array<UnknownGroupInput>;
  values: Array<FieldValueInput>;
};

export type EditActivityPayload = {
  __typename?: 'EditActivityPayload';
  activity?: Maybe<Activity>;
  errors?: Maybe<Array<EditActivityError>>;
};

export type EditCustomPropertyError = DuplicateNameError | NotFoundError | ValidationResultError;

export type EditCustomPropertyInput = {
  allowMultipleValues: Scalars['Boolean'];
  customOptions?: InputMaybe<Array<CustomOptionInput>>;
  id: Scalars['Int'];
  isRequired: Scalars['Boolean'];
  numberOfLines: Scalars['Int'];
  propertyDescription: Scalars['String'];
  propertyName: Scalars['String'];
  status: CustomFieldStatusType;
};

export type EditCustomPropertyPayload = {
  __typename?: 'EditCustomPropertyPayload';
  customField?: Maybe<CustomField>;
  errors?: Maybe<Array<EditCustomPropertyError>>;
};

export type EditDistributionCategoryError = NotFoundError | ValidationResultError;

export type EditDistributionCategoryInput = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type EditDistributionCategoryPayload = {
  __typename?: 'EditDistributionCategoryPayload';
  errors?: Maybe<Array<EditDistributionCategoryError>>;
  int?: Maybe<Scalars['Int']>;
};

export type EditDistributionItemError = NotFoundError | ValidationResultError;

export type EditDistributionItemInput = {
  categoryIds: Array<Scalars['Int']>;
  description: Scalars['String'];
  id: Scalars['Int'];
  isDisabled: Scalars['Boolean'];
  name: Scalars['String'];
  unit: Scalars['String'];
};

export type EditDistributionItemPayload = {
  __typename?: 'EditDistributionItemPayload';
  errors?: Maybe<Array<EditDistributionItemError>>;
  int?: Maybe<Scalars['Int']>;
};

export type EditIndividualError = ValidationResultError;

export type EditIndividualInput = {
  id: Scalars['Int'];
  values: Array<FieldValueInput>;
};

export type EditIndividualPayload = {
  __typename?: 'EditIndividualPayload';
  errors?: Maybe<Array<EditIndividualError>>;
  individual?: Maybe<Individual>;
};

export type EditReportModelError = NotFoundError | ValidationResultError;

export type EditReportModelInput = {
  filterValues: ReportParametersInput;
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type EditReportModelPayload = {
  __typename?: 'EditReportModelPayload';
  errors?: Maybe<Array<EditReportModelError>>;
  report?: Maybe<Report>;
};

export type EditSectionError = DuplicateNameError | ValidationResultError;

export type EditSectionInput = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type EditSectionPayload = {
  __typename?: 'EditSectionPayload';
  customFieldSection?: Maybe<CustomFieldSection>;
  errors?: Maybe<Array<EditSectionError>>;
};

export type EditSettingsError = NotFoundError | ValidationError;

export type EditSettingsInput = {
  activityEditDelayDays?: InputMaybe<Scalars['Int']>;
  fiscalYearStart?: InputMaybe<Scalars['DateTime']>;
  isDistributionEnabled: Scalars['Boolean'];
  isInterventionEnabled: Scalars['Boolean'];
  isKnownIndividualsEnabled: Scalars['Boolean'];
  isMeetingEnabled: Scalars['Boolean'];
  isPresentationEnabled: Scalars['Boolean'];
  isRoutineEnabled: Scalars['Boolean'];
};

export type EditSettingsPayload = {
  __typename?: 'EditSettingsPayload';
  errors?: Maybe<Array<EditSettingsError>>;
  setting?: Maybe<Setting>;
};

export type EditSpecificationsError = DuplicateNameError | ValidationResultError;

export type EditSpecificationsInput = {
  inputs: Array<SpecificationInput>;
  themeId: Scalars['Int'];
};

export type EditSpecificationsPayload = {
  __typename?: 'EditSpecificationsPayload';
  errors?: Maybe<Array<EditSpecificationsError>>;
  int?: Maybe<Scalars['Int']>;
};

export type EditTeamError = NotFoundError | ValidationResultError;

export type EditTeamInput = {
  description: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type EditTeamPayload = {
  __typename?: 'EditTeamPayload';
  errors?: Maybe<Array<EditTeamError>>;
  team?: Maybe<Team>;
};

export type EditTenantError = ValidationResultError;

export type EditTenantInput = {
  email?: InputMaybe<Scalars['String']>;
  extensionTelephone?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isIncludedInGlobalReport: Scalars['Boolean'];
  name: Scalars['String'];
  region: Scalars['String'];
  telephone: Scalars['String'];
  town: Scalars['String'];
};

export type EditTenantPayload = {
  __typename?: 'EditTenantPayload';
  errors?: Maybe<Array<EditTenantError>>;
  tenant?: Maybe<Tenant>;
};

export type EditUserDetailsError = NotFoundError | ValidationResultError;

export type EditUserDetailsInput = {
  firstName: Scalars['String'];
  id: Scalars['String'];
  lastName: Scalars['String'];
};

export type EditUserDetailsPayload = {
  __typename?: 'EditUserDetailsPayload';
  applicationUser?: Maybe<ApplicationUser>;
  errors?: Maybe<Array<EditUserDetailsError>>;
};

export type EnsureAllIndividualsHaveATeamError = ValidationResultError;

export type EnsureAllIndividualsHaveATeamPayload = {
  __typename?: 'EnsureAllIndividualsHaveATeamPayload';
  errors?: Maybe<Array<EnsureAllIndividualsHaveATeamError>>;
  string?: Maybe<Array<Scalars['String']>>;
};

export enum EntityType {
  Distribution = 'Distribution',
  Individual = 'Individual',
  Intervention = 'Intervention',
  Meeting = 'Meeting',
  Presentation = 'Presentation',
  Reality = 'Reality',
  Routine = 'Routine',
  UnknownGroup = 'UnknownGroup'
}

export type EntityTypeOperationFilterInput = {
  eq?: InputMaybe<EntityType>;
  in?: InputMaybe<Array<EntityType>>;
  neq?: InputMaybe<EntityType>;
  nin?: InputMaybe<Array<EntityType>>;
};

export type Error = {
  message: Scalars['String'];
};

export type FieldSectionDto = {
  __typename?: 'FieldSectionDto';
  entityType: EntityType;
  fieldEntityTypes: Array<CustomFieldEntityType>;
  id: Scalars['Int'];
  name: Scalars['String'];
  order: Scalars['Int'];
};


export type FieldSectionDtoFieldEntityTypesArgs = {
  order?: InputMaybe<Array<CustomFieldEntityTypeSortInput>>;
};

export type FieldSectionDtoFilterInput = {
  and?: InputMaybe<Array<FieldSectionDtoFilterInput>>;
  entityType?: InputMaybe<EntityTypeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FieldSectionDtoFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
};

export type FieldValueInput = {
  customFieldId: Scalars['Int'];
  displayString?: InputMaybe<Scalars['String']>;
  systemFieldId?: InputMaybe<SystemFieldId>;
  value?: InputMaybe<Scalars['String']>;
};

export type IdentityError = {
  __typename?: 'IdentityError';
  code: Scalars['String'];
  description: Scalars['String'];
};

export type IdentityResultError = Error & {
  __typename?: 'IdentityResultError';
  errors: Array<IdentityError>;
  message: Scalars['String'];
};

export type Individual = {
  __typename?: 'Individual';
  /** CustomFieldValues.Field.SystemId, CustomFieldValues.dateValue needs to be included for this property */
  birthday?: Maybe<Scalars['String']>;
  createdBy: ApplicationUser;
  createdOn: Scalars['DateTime'];
  customFieldValues: Array<CustomFieldValue>;
  /** CustomFieldValues.Field.SystemId, SelectionValues.Id needs to be included for this property */
  gender?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  nickName?: Maybe<Scalars['String']>;
};


export type IndividualCustomFieldValuesArgs = {
  where?: InputMaybe<CustomFieldValueFilterInput>;
};

export type IndividualFilterInput = {
  and?: InputMaybe<Array<IndividualFilterInput>>;
  createdBy?: InputMaybe<ApplicationUserFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  customFieldValues?: InputMaybe<ListFilterInputTypeOfCustomFieldValueFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<IndividualFilterInput>>;
  owningTeamId?: InputMaybe<IntOperationFilterInput>;
};

export type IndividualsByGender = {
  __typename?: 'IndividualsByGender';
  count: Scalars['Decimal'];
  gender: Scalars['String'];
};

/** A segment of a collection. */
export type IndividualsCollectionSegment = {
  __typename?: 'IndividualsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Individual>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  ngt?: InputMaybe<Scalars['Int']>;
  ngte?: InputMaybe<Scalars['Int']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  nlt?: InputMaybe<Scalars['Int']>;
  nlte?: InputMaybe<Scalars['Int']>;
};

export type InviteUserError = IdentityResultError | ValidationError;

export type InviteUserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  preferredCommunicationLanguage?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<BuiltInRoles>;
  teamIds: Array<Scalars['Int']>;
};

export type InviteUserPayload = {
  __typename?: 'InviteUserPayload';
  applicationUser?: Maybe<ApplicationUser>;
  errors?: Maybe<Array<InviteUserError>>;
};

export type LatestIndividuals = {
  __typename?: 'LatestIndividuals';
  activityDate: Scalars['DateTime'];
  birthday: Scalars['DateTime'];
  genderId: Scalars['Int'];
  id: Scalars['Int'];
  nickname: Scalars['String'];
};

export type ListFilterInputTypeOfApplicationRoleFilterInput = {
  all?: InputMaybe<ApplicationRoleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ApplicationRoleFilterInput>;
  some?: InputMaybe<ApplicationRoleFilterInput>;
};

export type ListFilterInputTypeOfApplicationUserFilterInput = {
  all?: InputMaybe<ApplicationUserFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ApplicationUserFilterInput>;
  some?: InputMaybe<ApplicationUserFilterInput>;
};

export type ListFilterInputTypeOfCustomFieldEntityTypeFilterInput = {
  all?: InputMaybe<CustomFieldEntityTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomFieldEntityTypeFilterInput>;
  some?: InputMaybe<CustomFieldEntityTypeFilterInput>;
};

export type ListFilterInputTypeOfCustomFieldI18nFilterInput = {
  all?: InputMaybe<CustomFieldI18nFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomFieldI18nFilterInput>;
  some?: InputMaybe<CustomFieldI18nFilterInput>;
};

export type ListFilterInputTypeOfCustomFieldOptionFilterInput = {
  all?: InputMaybe<CustomFieldOptionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomFieldOptionFilterInput>;
  some?: InputMaybe<CustomFieldOptionFilterInput>;
};

export type ListFilterInputTypeOfCustomFieldOptionI18nFilterInput = {
  all?: InputMaybe<CustomFieldOptionI18nFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomFieldOptionI18nFilterInput>;
  some?: InputMaybe<CustomFieldOptionI18nFilterInput>;
};

export type ListFilterInputTypeOfCustomFieldValueFilterInput = {
  all?: InputMaybe<CustomFieldValueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomFieldValueFilterInput>;
  some?: InputMaybe<CustomFieldValueFilterInput>;
};

export type ListFilterInputTypeOfIndividualFilterInput = {
  all?: InputMaybe<IndividualFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<IndividualFilterInput>;
  some?: InputMaybe<IndividualFilterInput>;
};

export type ListFilterInputTypeOfRealityFilterInput = {
  all?: InputMaybe<RealityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<RealityFilterInput>;
  some?: InputMaybe<RealityFilterInput>;
};

export type ListFilterInputTypeOfRealitySpecificationFilterInput = {
  all?: InputMaybe<RealitySpecificationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<RealitySpecificationFilterInput>;
  some?: InputMaybe<RealitySpecificationFilterInput>;
};

export type ListFilterInputTypeOfRealitySpecificationI18nFilterInput = {
  all?: InputMaybe<RealitySpecificationI18nFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<RealitySpecificationI18nFilterInput>;
  some?: InputMaybe<RealitySpecificationI18nFilterInput>;
};

export type ListFilterInputTypeOfRealityThemeI18nFilterInput = {
  all?: InputMaybe<RealityThemeI18nFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<RealityThemeI18nFilterInput>;
  some?: InputMaybe<RealityThemeI18nFilterInput>;
};

export type ListFilterInputTypeOfTeamFilterInput = {
  all?: InputMaybe<TeamFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TeamFilterInput>;
  some?: InputMaybe<TeamFilterInput>;
};

export type LookupFilter = {
  __typename?: 'LookupFilter';
  teamIds?: Maybe<Array<Scalars['Int']>>;
  userIds?: Maybe<Array<Scalars['String']>>;
};

export type LookupFilterInput = {
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type MergeIndividualsError = NotFoundError | ValidationResultError;

export type MergeIndividualsInput = {
  individualToKeepId: Scalars['Int'];
  individualToMergeId: Scalars['Int'];
};

export type MergeIndividualsPayload = {
  __typename?: 'MergeIndividualsPayload';
  errors?: Maybe<Array<MergeIndividualsError>>;
  individual?: Maybe<Individual>;
};

export type MigrateAccompanimentOptionsError = ValidationResultError;

export type MigrateAccompanimentOptionsPayload = {
  __typename?: 'MigrateAccompanimentOptionsPayload';
  errors?: Maybe<Array<MigrateAccompanimentOptionsError>>;
  string?: Maybe<Array<Scalars['String']>>;
};

export type MissingConfigurationError = Error & {
  __typename?: 'MissingConfigurationError';
  message: Scalars['String'];
};

export type ModifyUserTeamsError = NotFoundError | ValidationResultError;

export type ModifyUserTeamsInput = {
  teamIds: Array<Scalars['Int']>;
  userId: Scalars['String'];
};

export type ModifyUserTeamsPayload = {
  __typename?: 'ModifyUserTeamsPayload';
  applicationUser?: Maybe<ApplicationUser>;
  errors?: Maybe<Array<ModifyUserTeamsError>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addActivity: AddActivityPayload;
  addCustomProperty: AddCustomPropertyPayload;
  addDistributionCategory: AddDistributionCategoryPayload;
  addDistributionItem: AddDistributionItemPayload;
  addFieldToEntityType: AddFieldToEntityTypePayload;
  addIndividual: AddIndividualPayload;
  addReportModel: AddReportModelPayload;
  addSection: AddSectionPayload;
  addTeam: AddTeamPayload;
  addTeamMembers: AddTeamMembersPayload;
  addTenant: AddTenantPayload;
  deactivateUser: DeactivateUserPayload;
  deleteActivity: DeleteActivityPayload;
  deleteCustomField: DeleteCustomFieldPayload;
  deleteDistributionCategory: DeleteDistributionCategoryPayload;
  deleteDistributionItem: DeleteDistributionItemPayload;
  deleteIndividual: DeleteIndividualPayload;
  deleteReportModel: DeleteReportModelPayload;
  deleteSection: DeleteSectionPayload;
  deleteTeam: DeleteTeamPayload;
  editActivity: EditActivityPayload;
  editCustomProperty: EditCustomPropertyPayload;
  editDistributionCategory: EditDistributionCategoryPayload;
  editDistributionItem: EditDistributionItemPayload;
  editIndividual: EditIndividualPayload;
  editReportModel: EditReportModelPayload;
  editSection: EditSectionPayload;
  editSettings: EditSettingsPayload;
  editSpecifications: EditSpecificationsPayload;
  editTeam: EditTeamPayload;
  editTenant: EditTenantPayload;
  editUserDetails: EditUserDetailsPayload;
  ensureAllIndividualsHaveATeam: EnsureAllIndividualsHaveATeamPayload;
  inviteUser: InviteUserPayload;
  mergeIndividuals: MergeIndividualsPayload;
  migrateAccompanimentOptions: MigrateAccompanimentOptionsPayload;
  modifyUserTeams: ModifyUserTeamsPayload;
  removeFieldFromEntityType: RemoveFieldFromEntityTypePayload;
  removeTeamMember: RemoveTeamMemberPayload;
  reorderDistributionCategories: ReorderDistributionCategoriesPayload;
  reorderFields: ReorderFieldsPayload;
  restoreActivity: RestoreActivityPayload;
  restoreIndividual: RestoreIndividualPayload;
  updateUserRole: UpdateUserRolePayload;
};


export type MutationAddActivityArgs = {
  input: AddActivityInput;
};


export type MutationAddCustomPropertyArgs = {
  input: AddCustomPropertyInput;
};


export type MutationAddDistributionCategoryArgs = {
  input: AddDistributionCategoryInput;
};


export type MutationAddDistributionItemArgs = {
  input: AddDistributionItemInput;
};


export type MutationAddFieldToEntityTypeArgs = {
  input: AddFieldToEntityTypeInput;
};


export type MutationAddIndividualArgs = {
  input: AddIndividualInput;
};


export type MutationAddReportModelArgs = {
  input: AddReportModelInput;
};


export type MutationAddSectionArgs = {
  input: AddSectionInput;
};


export type MutationAddTeamArgs = {
  input: AddTeamInput;
};


export type MutationAddTeamMembersArgs = {
  input: AddTeamMembersInput;
};


export type MutationAddTenantArgs = {
  input: AddTenantInput;
};


export type MutationDeactivateUserArgs = {
  input: DeactivateUserInput;
};


export type MutationDeleteActivityArgs = {
  input: DeleteActivityInput;
};


export type MutationDeleteCustomFieldArgs = {
  input: DeleteCustomFieldInput;
};


export type MutationDeleteDistributionCategoryArgs = {
  input: DeleteDistributionCategoryInput;
};


export type MutationDeleteDistributionItemArgs = {
  input: DeleteDistributionItemInput;
};


export type MutationDeleteIndividualArgs = {
  input: DeleteIndividualInput;
};


export type MutationDeleteReportModelArgs = {
  input: DeleteReportModelInput;
};


export type MutationDeleteSectionArgs = {
  input: DeleteSectionInput;
};


export type MutationDeleteTeamArgs = {
  input: DeleteTeamInput;
};


export type MutationEditActivityArgs = {
  input: EditActivityInput;
};


export type MutationEditCustomPropertyArgs = {
  input: EditCustomPropertyInput;
};


export type MutationEditDistributionCategoryArgs = {
  input: EditDistributionCategoryInput;
};


export type MutationEditDistributionItemArgs = {
  input: EditDistributionItemInput;
};


export type MutationEditIndividualArgs = {
  input: EditIndividualInput;
};


export type MutationEditReportModelArgs = {
  input: EditReportModelInput;
};


export type MutationEditSectionArgs = {
  input: EditSectionInput;
};


export type MutationEditSettingsArgs = {
  input: EditSettingsInput;
};


export type MutationEditSpecificationsArgs = {
  input: EditSpecificationsInput;
};


export type MutationEditTeamArgs = {
  input: EditTeamInput;
};


export type MutationEditTenantArgs = {
  input: EditTenantInput;
};


export type MutationEditUserDetailsArgs = {
  input: EditUserDetailsInput;
};


export type MutationInviteUserArgs = {
  input: InviteUserInput;
  tenantId?: InputMaybe<Scalars['String']>;
};


export type MutationMergeIndividualsArgs = {
  input: MergeIndividualsInput;
};


export type MutationModifyUserTeamsArgs = {
  input: ModifyUserTeamsInput;
};


export type MutationRemoveFieldFromEntityTypeArgs = {
  input: RemoveFieldFromEntityTypeInput;
};


export type MutationRemoveTeamMemberArgs = {
  input: RemoveTeamMemberInput;
};


export type MutationReorderDistributionCategoriesArgs = {
  input: ReorderDistributionCategoriesInput;
};


export type MutationReorderFieldsArgs = {
  input: ReorderFieldsInput;
};


export type MutationRestoreActivityArgs = {
  input: RestoreActivityInput;
};


export type MutationRestoreIndividualArgs = {
  input: RestoreIndividualInput;
};


export type MutationUpdateUserRoleArgs = {
  input: UpdateUserRoleInput;
};

/** A segment of a collection. */
export type MyTeamsActivitiesCollectionSegment = {
  __typename?: 'MyTeamsActivitiesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Activity>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type NotFoundError = Error & {
  __typename?: 'NotFoundError';
  message: Scalars['String'];
};

export type NullableOfSystemFieldIdOperationFilterInput = {
  eq?: InputMaybe<SystemFieldId>;
  in?: InputMaybe<Array<InputMaybe<SystemFieldId>>>;
  neq?: InputMaybe<SystemFieldId>;
  nin?: InputMaybe<Array<InputMaybe<SystemFieldId>>>;
};

export type NumericalFilter = {
  __typename?: 'NumericalFilter';
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
};

export type NumericalFilterInput = {
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
};

export type PeriodFilter = {
  __typename?: 'PeriodFilter';
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
};

export type PeriodFilterInput = {
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
};

export type Query = {
  __typename?: 'Query';
  activeUsers: Array<ApplicationUser>;
  activities?: Maybe<ActivitiesCollectionSegment>;
  activitiesCountByDate: Array<ActivitiesCountByDate>;
  activitiesCountByTeam: Array<TeamStat>;
  activitiesCountByType: Array<ActivitiesCountByType>;
  categories: Array<DistributionCategoryDto>;
  customFieldOptionDtoResolver: Array<CustomFieldOptionDto>;
  customFields: Array<CustomFieldDto>;
  deletedActivities: Array<Activity>;
  deletedIndividuals: Array<Individual>;
  individuals?: Maybe<IndividualsCollectionSegment>;
  individualsCountByGender: Array<IndividualsByGender>;
  items: Array<DistributionItemDto>;
  latestActivities: Array<Activity>;
  latestIndividuals: Array<LatestIndividuals>;
  me: ApplicationUser;
  models: Array<Report>;
  myTeamsActivities?: Maybe<MyTeamsActivitiesCollectionSegment>;
  options: Array<CustomFieldOptionDto>;
  reportCount: ReportCountValues;
  searchIndividuals?: Maybe<SearchIndividualsCollectionSegment>;
  sections: Array<FieldSectionDto>;
  settings: Array<Setting>;
  specifications: Array<RealitySpecificationDto>;
  teams: Array<Team>;
  tenants: Array<Tenant>;
  themes: Array<RealityThemeDto>;
  topDistributedItems: Array<DistributedItems>;
  unknownGroups: Array<UnknownGroup>;
  users: Array<ApplicationUser>;
  usersByTenant: Array<ApplicationUser>;
};


export type QueryActiveUsersArgs = {
  where?: InputMaybe<ApplicationUserFilterInput>;
};


export type QueryActivitiesArgs = {
  searchTerm?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActivityFilterInput>;
};


export type QueryActivitiesCountByDateArgs = {
  where?: InputMaybe<ActivityFilterInput>;
};


export type QueryActivitiesCountByTeamArgs = {
  where?: InputMaybe<ActivityFilterInput>;
};


export type QueryActivitiesCountByTypeArgs = {
  where?: InputMaybe<ActivityFilterInput>;
};


export type QueryCategoriesArgs = {
  where?: InputMaybe<DistributionCategoryDtoFilterInput>;
};


export type QueryCustomFieldsArgs = {
  where?: InputMaybe<CustomFieldDtoFilterInput>;
};


export type QueryDeletedActivitiesArgs = {
  where?: InputMaybe<ActivityFilterInput>;
};


export type QueryDeletedIndividualsArgs = {
  where?: InputMaybe<IndividualFilterInput>;
};


export type QueryIndividualsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IndividualFilterInput>;
};


export type QueryIndividualsCountByGenderArgs = {
  where?: InputMaybe<ActivityFilterInput>;
};


export type QueryItemsArgs = {
  where?: InputMaybe<DistributionItemDtoFilterInput>;
};


export type QueryLatestActivitiesArgs = {
  where?: InputMaybe<ActivityFilterInput>;
};


export type QueryLatestIndividualsArgs = {
  where?: InputMaybe<ActivityFilterInput>;
};


export type QueryMyTeamsActivitiesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActivityFilterInput>;
};


export type QueryOptionsArgs = {
  order?: InputMaybe<Array<CustomFieldOptionDtoSortInput>>;
  where?: InputMaybe<CustomFieldOptionDtoFilterInput>;
};


export type QueryReportCountArgs = {
  input: ReportParametersInput;
};


export type QuerySearchIndividualsArgs = {
  searchTerm: Scalars['String'];
  showDeleted?: Scalars['Boolean'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IndividualFilterInput>;
};


export type QuerySectionsArgs = {
  where?: InputMaybe<FieldSectionDtoFilterInput>;
};


export type QuerySpecificationsArgs = {
  where?: InputMaybe<RealitySpecificationDtoFilterInput>;
};


export type QueryTeamsArgs = {
  where?: InputMaybe<TeamFilterInput>;
};


export type QueryTenantsArgs = {
  where?: InputMaybe<TenantFilterInput>;
};


export type QueryThemesArgs = {
  where?: InputMaybe<RealityThemeDtoFilterInput>;
};


export type QueryTopDistributedItemsArgs = {
  where?: InputMaybe<ActivityFilterInput>;
};


export type QueryUnknownGroupsArgs = {
  where?: InputMaybe<UnknownGroupFilterInput>;
};


export type QueryUsersArgs = {
  where?: InputMaybe<ApplicationUserFilterInput>;
};


export type QueryUsersByTenantArgs = {
  tenantId: Scalars['String'];
  where?: InputMaybe<ApplicationUserFilterInput>;
};

export type Reality = {
  __typename?: 'Reality';
  id: Scalars['Int'];
  specification: RealitySpecification;
  specificationId: Scalars['Int'];
  theme: RealityTheme;
  themeId: Scalars['Int'];
  values: Array<CustomFieldValue>;
};


export type RealityValuesArgs = {
  where?: InputMaybe<CustomFieldValueFilterInput>;
};

export type RealityFilterInput = {
  and?: InputMaybe<Array<RealityFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<RealityFilterInput>>;
  specification?: InputMaybe<RealitySpecificationFilterInput>;
  specificationId?: InputMaybe<IntOperationFilterInput>;
  theme?: InputMaybe<RealityThemeFilterInput>;
  themeId?: InputMaybe<IntOperationFilterInput>;
  values?: InputMaybe<ListFilterInputTypeOfCustomFieldValueFilterInput>;
};

export type RealityInput = {
  accompanimentIds: Array<Scalars['Int']>;
  accompanimentOtherValue?: InputMaybe<Scalars['String']>;
  approachIds: Array<Scalars['Int']>;
  approachOtherValue?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  referralIds: Array<Scalars['Int']>;
  referralOtherValue?: InputMaybe<Scalars['String']>;
  specificationId: Scalars['Int'];
  themeId: Scalars['Int'];
};

export type RealitySpecification = {
  __typename?: 'RealitySpecification';
  i18n: Array<RealitySpecificationI18n>;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  order: Scalars['Int'];
  realities: Array<Reality>;
  theme: RealityTheme;
  themeId: Scalars['Int'];
};

export type RealitySpecificationDto = {
  __typename?: 'RealitySpecificationDto';
  id: Scalars['Int'];
  name: Scalars['String'];
  themeId: Scalars['Int'];
};

export type RealitySpecificationDtoFilterInput = {
  and?: InputMaybe<Array<RealitySpecificationDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RealitySpecificationDtoFilterInput>>;
};

export type RealitySpecificationFilterInput = {
  and?: InputMaybe<Array<RealitySpecificationFilterInput>>;
  i18n?: InputMaybe<ListFilterInputTypeOfRealitySpecificationI18nFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<RealitySpecificationFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  realities?: InputMaybe<ListFilterInputTypeOfRealityFilterInput>;
  theme?: InputMaybe<RealityThemeFilterInput>;
  themeId?: InputMaybe<IntOperationFilterInput>;
};

export type RealitySpecificationI18n = {
  __typename?: 'RealitySpecificationI18n';
  isDeleted: Scalars['Boolean'];
  language: Scalars['String'];
  name: Scalars['String'];
  specification: RealitySpecification;
  specificationId: Scalars['Int'];
};

export type RealitySpecificationI18nFilterInput = {
  and?: InputMaybe<Array<RealitySpecificationI18nFilterInput>>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  language?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RealitySpecificationI18nFilterInput>>;
  specification?: InputMaybe<RealitySpecificationFilterInput>;
  specificationId?: InputMaybe<IntOperationFilterInput>;
};

export type RealityTheme = {
  __typename?: 'RealityTheme';
  i18n: Array<RealityThemeI18n>;
  id: Scalars['Int'];
  realities: Array<Reality>;
  specifications: Array<RealitySpecification>;
};

export type RealityThemeDto = {
  __typename?: 'RealityThemeDto';
  description: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  specifications: Array<RealitySpecificationDto>;
};

export type RealityThemeDtoFilterInput = {
  and?: InputMaybe<Array<RealityThemeDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RealityThemeDtoFilterInput>>;
};

export type RealityThemeFilterInput = {
  and?: InputMaybe<Array<RealityThemeFilterInput>>;
  i18n?: InputMaybe<ListFilterInputTypeOfRealityThemeI18nFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<RealityThemeFilterInput>>;
  realities?: InputMaybe<ListFilterInputTypeOfRealityFilterInput>;
  specifications?: InputMaybe<ListFilterInputTypeOfRealitySpecificationFilterInput>;
};

export type RealityThemeI18n = {
  __typename?: 'RealityThemeI18n';
  description: Scalars['String'];
  language: Scalars['String'];
  name: Scalars['String'];
  theme: RealityTheme;
  themeId: Scalars['Int'];
};

export type RealityThemeI18nFilterInput = {
  and?: InputMaybe<Array<RealityThemeI18nFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  language?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RealityThemeI18nFilterInput>>;
  theme?: InputMaybe<RealityThemeFilterInput>;
  themeId?: InputMaybe<IntOperationFilterInput>;
};

export type RemoveFieldFromEntityTypeError = ValidationResultError;

export type RemoveFieldFromEntityTypeInput = {
  customFieldId: Scalars['Int'];
  entityType: EntityType;
};

export type RemoveFieldFromEntityTypePayload = {
  __typename?: 'RemoveFieldFromEntityTypePayload';
  customField?: Maybe<CustomField>;
  errors?: Maybe<Array<RemoveFieldFromEntityTypeError>>;
};

export type RemoveTeamMemberError = NotFoundError | ValidationResultError;

export type RemoveTeamMemberInput = {
  memberId: Scalars['String'];
  teamId: Scalars['Int'];
};

export type RemoveTeamMemberPayload = {
  __typename?: 'RemoveTeamMemberPayload';
  errors?: Maybe<Array<RemoveTeamMemberError>>;
  team?: Maybe<Team>;
};

export type ReorderCategoryInput = {
  ordering: Array<Scalars['Int']>;
};

export type ReorderDistributionCategoriesError = ValidationResultError;

export type ReorderDistributionCategoriesInput = {
  input: ReorderCategoryInput;
};

export type ReorderDistributionCategoriesPayload = {
  __typename?: 'ReorderDistributionCategoriesPayload';
  distributionCategory?: Maybe<Array<DistributionCategory>>;
  errors?: Maybe<Array<ReorderDistributionCategoriesError>>;
};

export type ReorderFieldsError = DuplicateNameError | ValidationResultError;

export type ReorderFieldsInput = {
  entityType: EntityType;
  ordering: Array<SectionReorderInput>;
};

export type ReorderFieldsPayload = {
  __typename?: 'ReorderFieldsPayload';
  customFieldSection?: Maybe<Array<CustomFieldSection>>;
  errors?: Maybe<Array<ReorderFieldsError>>;
};

export type Report = {
  __typename?: 'Report';
  id: Scalars['Int'];
  lastUpdated: Scalars['DateTime'];
  name: Scalars['String'];
  reportValues: ReportParameters;
};

export type ReportCountValues = {
  __typename?: 'ReportCountValues';
  activitiesCount: Scalars['Int'];
  individualsCount: Scalars['Int'];
};

export type ReportFieldFilter = {
  __typename?: 'ReportFieldFilter';
  customFieldId: Scalars['Int'];
  dateFilter?: Maybe<DateFilter>;
  lookupFilter?: Maybe<LookupFilter>;
  numericalFilter?: Maybe<NumericalFilter>;
  selectionFilter?: Maybe<SelectionFilter>;
  systemFieldId?: Maybe<SystemFieldId>;
};

export type ReportFieldFilterInput = {
  customFieldId: Scalars['Int'];
  dateFilter?: InputMaybe<DateFilterInput>;
  lookupFilter?: InputMaybe<LookupFilterInput>;
  numericalFilter?: InputMaybe<NumericalFilterInput>;
  selectionFilter?: InputMaybe<SelectionFilterInput>;
  systemFieldId?: InputMaybe<SystemFieldId>;
};

export type ReportFieldsVisibility = {
  __typename?: 'ReportFieldsVisibility';
  areActivityTypesVisible: Scalars['Boolean'];
  areDistributionsVisible: Scalars['Boolean'];
  areSpecificationsVisible: Scalars['Boolean'];
  areThemesVisible: Scalars['Boolean'];
  visibleCustomFieldIds?: Maybe<Array<Scalars['Int']>>;
};

export type ReportFieldsVisibilityInput = {
  areActivityTypesVisible: Scalars['Boolean'];
  areDistributionsVisible: Scalars['Boolean'];
  areSpecificationsVisible: Scalars['Boolean'];
  areThemesVisible: Scalars['Boolean'];
  visibleCustomFieldIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type ReportFilterValues = {
  __typename?: 'ReportFilterValues';
  activityTypes: Array<ActivityType>;
  categoryIds: Array<Scalars['Int']>;
  customFieldFilters: Array<ReportFieldFilter>;
  distributedAmounts?: Maybe<NumericalFilter>;
  individualsFieldFilters: Array<ReportFieldFilter>;
  itemIds: Array<Scalars['Int']>;
  period: PeriodFilter;
  realitiesFieldFilters: Array<ReportFieldFilter>;
  specificationIds: Array<Scalars['Int']>;
  themeIds: Array<Scalars['Int']>;
  unknownGroupFieldFilters: Array<ReportFieldFilter>;
  useOutreachWorkersOrLogic: Scalars['Boolean'];
};

export type ReportFilterValuesInput = {
  activityTypes: Array<ActivityType>;
  categoryIds: Array<Scalars['Int']>;
  customFieldFilters: Array<ReportFieldFilterInput>;
  distributedAmounts?: InputMaybe<NumericalFilterInput>;
  individualsFieldFilters: Array<ReportFieldFilterInput>;
  itemIds: Array<Scalars['Int']>;
  period: PeriodFilterInput;
  realitiesFieldFilters: Array<ReportFieldFilterInput>;
  specificationIds: Array<Scalars['Int']>;
  themeIds: Array<Scalars['Int']>;
  unknownGroupFieldFilters: Array<ReportFieldFilterInput>;
  useOutreachWorkersOrLogic: Scalars['Boolean'];
};

export enum ReportGenderBreakdown {
  ByColumn = 'ByColumn',
  ByRow = 'ByRow',
  None = 'None'
}

export type ReportParameters = {
  __typename?: 'ReportParameters';
  ageGroupBoundaries: Array<Scalars['Int']>;
  fieldsVisibility?: Maybe<ReportFieldsVisibility>;
  filters: ReportFilterValues;
  genderBreakdown: ReportGenderBreakdown;
  includeUnknownIndividuals: Scalars['Boolean'];
};

export type ReportParametersInput = {
  ageGroupBoundaries: Array<Scalars['Int']>;
  fieldsVisibility?: InputMaybe<ReportFieldsVisibilityInput>;
  filters: ReportFilterValuesInput;
  genderBreakdown: ReportGenderBreakdown;
  includeUnknownIndividuals: Scalars['Boolean'];
};

export type RestoreActivityError = NotFoundError | ValidationResultError;

export type RestoreActivityInput = {
  id: Scalars['Int'];
};

export type RestoreActivityPayload = {
  __typename?: 'RestoreActivityPayload';
  activity?: Maybe<Activity>;
  errors?: Maybe<Array<RestoreActivityError>>;
};

export type RestoreIndividualError = NotFoundError | ValidationResultError;

export type RestoreIndividualInput = {
  id: Scalars['Int'];
};

export type RestoreIndividualPayload = {
  __typename?: 'RestoreIndividualPayload';
  errors?: Maybe<Array<RestoreIndividualError>>;
  individual?: Maybe<Individual>;
};

/** A segment of a collection. */
export type SearchIndividualsCollectionSegment = {
  __typename?: 'SearchIndividualsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Individual>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type SectionReorderInput = {
  fieldsOrdering: Array<Scalars['Int']>;
  sectionId: Scalars['Int'];
};

export type SelectionFilter = {
  __typename?: 'SelectionFilter';
  optionIds: Array<Scalars['Int']>;
};

export type SelectionFilterInput = {
  optionIds: Array<Scalars['Int']>;
};

export type Setting = {
  __typename?: 'Setting';
  activityEditDelayDays: Scalars['Int'];
  fiscalYearStart?: Maybe<Scalars['DateTime']>;
  isDistributionEnabled: Scalars['Boolean'];
  isInterventionEnabled: Scalars['Boolean'];
  isKnownIndividualsEnabled: Scalars['Boolean'];
  isMeetingEnabled: Scalars['Boolean'];
  isPresentationEnabled: Scalars['Boolean'];
  isRoutineEnabled: Scalars['Boolean'];
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SpecificationInput = {
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ncontains?: InputMaybe<Scalars['String']>;
  nendsWith?: InputMaybe<Scalars['String']>;
  neq?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nstartsWith?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  activityAdded: ActivityAdded;
  activityUpdated: ActivityUpdated;
  customFieldAdded: CustomField;
  customFieldUpdated: CustomField;
};

export enum SystemFieldId {
  AccompanimentOtherValue = 'AccompanimentOtherValue',
  AdditionalWorkers = 'AdditionalWorkers',
  ApproachOtherValue = 'ApproachOtherValue',
  AverageAge = 'AverageAge',
  Birthday = 'Birthday',
  /** @deprecated For privacy purposes, the first name is no longer asked for. */
  FirstName = 'FirstName',
  Gender = 'Gender',
  InterventionDate = 'InterventionDate',
  /** @deprecated For privacy purposes, the last name is no longer asked for. */
  LastName = 'LastName',
  NickName = 'NickName',
  NumberOfUsers = 'NumberOfUsers',
  OutreachWorker = 'OutreachWorker',
  RealityAccompaniments = 'RealityAccompaniments',
  RealityApproaches = 'RealityApproaches',
  RealityReferrals = 'RealityReferrals',
  ReferralOtherValue = 'ReferralOtherValue',
  Team = 'Team'
}

export type Team = {
  __typename?: 'Team';
  description: Scalars['String'];
  id: Scalars['Int'];
  isDefault: Scalars['Boolean'];
  members: Array<ApplicationUser>;
  name: Scalars['String'];
};

export type TeamFilterInput = {
  and?: InputMaybe<Array<TeamFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  members?: InputMaybe<ListFilterInputTypeOfApplicationUserFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TeamFilterInput>>;
};

export type TeamStat = {
  __typename?: 'TeamStat';
  distributions: Scalars['Int'];
  id: Scalars['String'];
  interventions: Scalars['Int'];
  lastActivityDate: Scalars['DateTime'];
  meetings: Scalars['Int'];
  name: Scalars['String'];
  presentations: Scalars['Int'];
  routines: Scalars['Int'];
  teamId: Scalars['Int'];
  teamName: Scalars['String'];
};

export type Tenant = {
  __typename?: 'Tenant';
  email?: Maybe<Scalars['String']>;
  extensionTelephone?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  isIncludedInGlobalReport: Scalars['Boolean'];
  isProvisioned: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
  town?: Maybe<Scalars['String']>;
};

export type TenantFilterInput = {
  and?: InputMaybe<Array<TenantFilterInput>>;
  email?: InputMaybe<StringOperationFilterInput>;
  extensionTelephone?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  identifier?: InputMaybe<StringOperationFilterInput>;
  isIncludedInGlobalReport?: InputMaybe<BooleanOperationFilterInput>;
  isProvisioned?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TenantFilterInput>>;
  region?: InputMaybe<StringOperationFilterInput>;
  telephone?: InputMaybe<StringOperationFilterInput>;
  town?: InputMaybe<StringOperationFilterInput>;
};

export type TenantInput = {
  email?: InputMaybe<Scalars['String']>;
  extensionTelephone?: InputMaybe<Scalars['String']>;
  identifier: Scalars['String'];
  isIncludedInGlobalReport: Scalars['Boolean'];
  name: Scalars['String'];
  region: Scalars['String'];
  telephone: Scalars['String'];
  town: Scalars['String'];
};

export type UnknownGroup = {
  __typename?: 'UnknownGroup';
  activityId: Scalars['Int'];
  averageAge: Scalars['Decimal'];
  customFieldValues: Array<CustomFieldValue>;
  /** CustomFieldValues.Field.SystemId, SelectionValues.Id needs to be included for this property */
  gender?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** CustomFieldValues.Field.SystemId, CustomFieldValues.NumericalValue needs to be included for this property */
  numberOfUsers: Scalars['Decimal'];
};


export type UnknownGroupCustomFieldValuesArgs = {
  where?: InputMaybe<CustomFieldValueFilterInput>;
};

export type UnknownGroupFilterInput = {
  activityId?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<UnknownGroupFilterInput>>;
  customFieldValues?: InputMaybe<ListFilterInputTypeOfCustomFieldValueFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<UnknownGroupFilterInput>>;
};

export type UnknownGroupInput = {
  id?: InputMaybe<Scalars['Int']>;
  systemFieldId?: InputMaybe<SystemFieldId>;
  values: Array<FieldValueInput>;
};

export type UpdateUserRoleError = IdentityResultError | ValidationError;

export type UpdateUserRoleInput = {
  role?: InputMaybe<BuiltInRoles>;
  userId: Scalars['String'];
};

export type UpdateUserRolePayload = {
  __typename?: 'UpdateUserRolePayload';
  errors?: Maybe<Array<UpdateUserRoleError>>;
  userRoleUpdated?: Maybe<UserRoleUpdated>;
};

export type UserRoleUpdated = {
  __typename?: 'UserRoleUpdated';
  role?: Maybe<BuiltInRoles>;
  userId: Scalars['String'];
};

export enum UserStatusType {
  Active = 'Active',
  Inactive = 'Inactive',
  InvitePending = 'InvitePending'
}

export type UserStatusTypeOperationFilterInput = {
  eq?: InputMaybe<UserStatusType>;
  in?: InputMaybe<Array<UserStatusType>>;
  neq?: InputMaybe<UserStatusType>;
  nin?: InputMaybe<Array<UserStatusType>>;
};

export type ValidationAttribute = {
  __typename?: 'ValidationAttribute';
  errorMessage?: Maybe<Scalars['String']>;
  errorMessageResourceName?: Maybe<Scalars['String']>;
  formatErrorMessage: Scalars['String'];
  isDefaultAttribute: Scalars['Boolean'];
  requiresValidationContext: Scalars['Boolean'];
};


export type ValidationAttributeFormatErrorMessageArgs = {
  name: Scalars['String'];
};

export type ValidationError = Error & {
  __typename?: 'ValidationError';
  message: Scalars['String'];
  validationAttribute?: Maybe<ValidationAttribute>;
  validationResult: ValidationResult;
};

export type ValidationResult = {
  __typename?: 'ValidationResult';
  errorMessage?: Maybe<Scalars['String']>;
  memberNames: Array<Scalars['String']>;
};

export type ValidationResultError = Error & {
  __typename?: 'ValidationResultError';
  message: Scalars['String'];
};

export type AddActivityMutationVariables = Exact<{
  input: AddActivityInput;
}>;


export type AddActivityMutation = { __typename?: 'Mutation', addActivity: { __typename?: 'AddActivityPayload', activity?: { __typename?: 'Activity', id: number } | null, errors?: Array<{ __typename?: 'NotFoundError', message: string } | { __typename?: 'ValidationResultError', message: string }> | null } };

export type DeleteActivityMutationVariables = Exact<{
  input: DeleteActivityInput;
}>;


export type DeleteActivityMutation = { __typename?: 'Mutation', deleteActivity: { __typename?: 'DeleteActivityPayload', activity?: { __typename?: 'Activity', id: number } | null, errors?: Array<{ __typename?: 'NotFoundError', message: string } | { __typename?: 'ValidationResultError', message: string }> | null } };

export type EditActivityMutationVariables = Exact<{
  input: EditActivityInput;
}>;


export type EditActivityMutation = { __typename?: 'Mutation', editActivity: { __typename?: 'EditActivityPayload', errors?: Array<{ __typename?: 'NotFoundError', message: string } | { __typename?: 'ValidationResultError', message: string }> | null } };

export type RestoreActivityMutationVariables = Exact<{
  input: RestoreActivityInput;
}>;


export type RestoreActivityMutation = { __typename?: 'Mutation', restoreActivity: { __typename?: 'RestoreActivityPayload', activity?: { __typename?: 'Activity', id: number } | null } };

export type CustomFieldValueFragmentFragment = { __typename?: 'CustomFieldValue', fieldId: number, id: number, stringValue?: string | null, numericalValue?: any | null, dateValue?: any | null, displayString: string, field: { __typename?: 'CustomField', id: number, systemFieldId?: SystemFieldId | null, fieldType: CustomFieldType }, selectionValues: Array<{ __typename?: 'CustomFieldOption', id: number }>, lookupUserValues: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string }>, lookupTeamValue?: { __typename?: 'Team', id: number, name: string, description: string, isDefault: boolean } | null };

export type FindActivitiesQueryVariables = Exact<{
  filter?: InputMaybe<ActivityFilterInput>;
  pageSize: Scalars['Int'];
  skip: Scalars['Int'];
  searchTerm?: InputMaybe<Scalars['String']>;
  includeIndividuals?: InputMaybe<Scalars['Boolean']>;
  includeUnknownGroups?: InputMaybe<Scalars['Boolean']>;
  includeRealities?: InputMaybe<Scalars['Boolean']>;
  filterValues?: InputMaybe<CustomFieldValueFilterInput>;
  filterIndividualValues?: InputMaybe<CustomFieldValueFilterInput>;
  filterUnknownGroupValues?: InputMaybe<CustomFieldValueFilterInput>;
  filterRealitiesValues?: InputMaybe<CustomFieldValueFilterInput>;
}>;


export type FindActivitiesQuery = { __typename?: 'Query', activities?: { __typename?: 'ActivitiesCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'Activity', id: number, type: ActivityType, createdAt: any, owningTeamId: number, createdById: string, isDeleted: boolean, customFieldValues: Array<{ __typename?: 'CustomFieldValue', fieldId: number, id: number, stringValue?: string | null, numericalValue?: any | null, dateValue?: any | null, displayString: string, field: { __typename?: 'CustomField', id: number, systemFieldId?: SystemFieldId | null, fieldType: CustomFieldType }, selectionValues: Array<{ __typename?: 'CustomFieldOption', id: number }>, lookupUserValues: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string }>, lookupTeamValue?: { __typename?: 'Team', id: number, name: string, description: string, isDefault: boolean } | null }>, individuals?: Array<{ __typename?: 'Individual', customFieldValues: Array<{ __typename?: 'CustomFieldValue', fieldId: number, id: number, stringValue?: string | null, numericalValue?: any | null, dateValue?: any | null, displayString: string, field: { __typename?: 'CustomField', id: number, systemFieldId?: SystemFieldId | null, fieldType: CustomFieldType }, selectionValues: Array<{ __typename?: 'CustomFieldOption', id: number }>, lookupUserValues: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string }>, lookupTeamValue?: { __typename?: 'Team', id: number, name: string, description: string, isDefault: boolean } | null }> }>, unknownGroups?: Array<{ __typename?: 'UnknownGroup', customFieldValues: Array<{ __typename?: 'CustomFieldValue', fieldId: number, id: number, stringValue?: string | null, numericalValue?: any | null, dateValue?: any | null, displayString: string, field: { __typename?: 'CustomField', id: number, systemFieldId?: SystemFieldId | null, fieldType: CustomFieldType }, selectionValues: Array<{ __typename?: 'CustomFieldOption', id: number }>, lookupUserValues: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string }>, lookupTeamValue?: { __typename?: 'Team', id: number, name: string, description: string, isDefault: boolean } | null }> }>, realities?: Array<{ __typename?: 'Reality', themeId: number, specificationId: number, values: Array<{ __typename?: 'CustomFieldValue', fieldId: number, id: number, stringValue?: string | null, numericalValue?: any | null, dateValue?: any | null, displayString: string, field: { __typename?: 'CustomField', id: number, systemFieldId?: SystemFieldId | null, fieldType: CustomFieldType }, selectionValues: Array<{ __typename?: 'CustomFieldOption', id: number }>, lookupUserValues: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string }>, lookupTeamValue?: { __typename?: 'Team', id: number, name: string, description: string, isDefault: boolean } | null }> }> }> | null } | null };

export type FindDeletedActivitiesQueryVariables = Exact<{
  filter?: InputMaybe<ActivityFilterInput>;
}>;


export type FindDeletedActivitiesQuery = { __typename?: 'Query', deletedActivities: Array<{ __typename?: 'Activity', id: number, type: ActivityType, createdAt: any, createdById: string, owningTeamId: number, isDeleted: boolean, customFieldValues: Array<{ __typename?: 'CustomFieldValue', fieldId: number, id: number, stringValue?: string | null, numericalValue?: any | null, dateValue?: any | null, displayString: string, field: { __typename?: 'CustomField', id: number, systemFieldId?: SystemFieldId | null, fieldType: CustomFieldType }, selectionValues: Array<{ __typename?: 'CustomFieldOption', id: number }>, lookupUserValues: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string }>, lookupTeamValue?: { __typename?: 'Team', id: number, name: string, description: string, isDefault: boolean } | null }>, distributions: Array<{ __typename?: 'DistributionValue', itemId: number }>, individuals: Array<{ __typename?: 'Individual', customFieldValues: Array<{ __typename?: 'CustomFieldValue', fieldId: number, id: number, stringValue?: string | null, numericalValue?: any | null, dateValue?: any | null, displayString: string, field: { __typename?: 'CustomField', id: number, systemFieldId?: SystemFieldId | null, fieldType: CustomFieldType }, selectionValues: Array<{ __typename?: 'CustomFieldOption', id: number }>, lookupUserValues: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string }>, lookupTeamValue?: { __typename?: 'Team', id: number, name: string, description: string, isDefault: boolean } | null }> }>, unknownGroups: Array<{ __typename?: 'UnknownGroup', customFieldValues: Array<{ __typename?: 'CustomFieldValue', fieldId: number, id: number, stringValue?: string | null, numericalValue?: any | null, dateValue?: any | null, displayString: string, field: { __typename?: 'CustomField', id: number, systemFieldId?: SystemFieldId | null, fieldType: CustomFieldType }, selectionValues: Array<{ __typename?: 'CustomFieldOption', id: number }>, lookupUserValues: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string }>, lookupTeamValue?: { __typename?: 'Team', id: number, name: string, description: string, isDefault: boolean } | null }> }>, realities: Array<{ __typename?: 'Reality', themeId: number, specificationId: number, values: Array<{ __typename?: 'CustomFieldValue', fieldId: number, id: number, stringValue?: string | null, numericalValue?: any | null, dateValue?: any | null, displayString: string, field: { __typename?: 'CustomField', id: number, systemFieldId?: SystemFieldId | null, fieldType: CustomFieldType }, selectionValues: Array<{ __typename?: 'CustomFieldOption', id: number }>, lookupUserValues: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string }>, lookupTeamValue?: { __typename?: 'Team', id: number, name: string, description: string, isDefault: boolean } | null }> }> }> };

export type FindMyTeamsActivitiesQueryVariables = Exact<{
  filter?: InputMaybe<ActivityFilterInput>;
  pageSize: Scalars['Int'];
  skip: Scalars['Int'];
}>;


export type FindMyTeamsActivitiesQuery = { __typename?: 'Query', myTeamsActivities?: { __typename?: 'MyTeamsActivitiesCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'Activity', id: number, type: ActivityType, createdAt: any, createdBy: { __typename?: 'ApplicationUser', firstName: string, lastName: string, displayName: string }, customFieldValues: Array<{ __typename?: 'CustomFieldValue', fieldId: number, id: number, stringValue?: string | null, numericalValue?: any | null, dateValue?: any | null, displayString: string, field: { __typename?: 'CustomField', systemFieldId?: SystemFieldId | null }, selectionValues: Array<{ __typename?: 'CustomFieldOption', id: number }> }> }> | null } | null };

export type GetActivityByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetActivityByIdQuery = { __typename?: 'Query', activities?: { __typename?: 'ActivitiesCollectionSegment', items?: Array<{ __typename?: 'Activity', id: number, type: ActivityType, owningTeamId: number, isDeleted: boolean, createdById: string, createdAt: any, createdBy: { __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string }, individuals: Array<{ __typename?: 'Individual', id: number, createdOn: any, createdBy: { __typename?: 'ApplicationUser', firstName: string, lastName: string, displayName: string }, customFieldValues: Array<{ __typename?: 'CustomFieldValue', fieldId: number, id: number, stringValue?: string | null, numericalValue?: any | null, dateValue?: any | null, displayString: string, field: { __typename?: 'CustomField', id: number, systemFieldId?: SystemFieldId | null, fieldType: CustomFieldType }, selectionValues: Array<{ __typename?: 'CustomFieldOption', id: number }>, lookupUserValues: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string }>, lookupTeamValue?: { __typename?: 'Team', id: number, name: string, description: string, isDefault: boolean } | null }> }>, unknownGroups: Array<{ __typename?: 'UnknownGroup', id: number, activityId: number, averageAge: any, numberOfUsers: any, gender?: string | null, customFieldValues: Array<{ __typename?: 'CustomFieldValue', fieldId: number, id: number, stringValue?: string | null, numericalValue?: any | null, dateValue?: any | null, displayString: string, field: { __typename?: 'CustomField', id: number, systemFieldId?: SystemFieldId | null, fieldType: CustomFieldType }, selectionValues: Array<{ __typename?: 'CustomFieldOption', id: number }>, lookupUserValues: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string }>, lookupTeamValue?: { __typename?: 'Team', id: number, name: string, description: string, isDefault: boolean } | null }> }>, realities: Array<{ __typename?: 'Reality', id: number, themeId: number, specificationId: number, values: Array<{ __typename?: 'CustomFieldValue', fieldId: number, id: number, stringValue?: string | null, numericalValue?: any | null, dateValue?: any | null, displayString: string, field: { __typename?: 'CustomField', id: number, systemFieldId?: SystemFieldId | null, fieldType: CustomFieldType }, selectionValues: Array<{ __typename?: 'CustomFieldOption', id: number }>, lookupUserValues: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string }>, lookupTeamValue?: { __typename?: 'Team', id: number, name: string, description: string, isDefault: boolean } | null }> }>, customFieldValues: Array<{ __typename?: 'CustomFieldValue', fieldId: number, id: number, stringValue?: string | null, numericalValue?: any | null, dateValue?: any | null, displayString: string, field: { __typename?: 'CustomField', id: number, systemFieldId?: SystemFieldId | null, fieldType: CustomFieldType }, selectionValues: Array<{ __typename?: 'CustomFieldOption', id: number }>, lookupUserValues: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string }>, lookupTeamValue?: { __typename?: 'Team', id: number, name: string, description: string, isDefault: boolean } | null }>, distributions: Array<{ __typename?: 'DistributionValue', itemId: number, distributedAmount: number }> }> | null } | null };

export type GetActivityTypesSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActivityTypesSettingsQuery = { __typename?: 'Query', settings: Array<{ __typename?: 'Setting', isDistributionEnabled: boolean, isInterventionEnabled: boolean, isMeetingEnabled: boolean, isPresentationEnabled: boolean, isRoutineEnabled: boolean }> };

export type GetDeletedActivityByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetDeletedActivityByIdQuery = { __typename?: 'Query', deletedActivities: Array<{ __typename?: 'Activity', id: number, type: ActivityType, owningTeamId: number, isDeleted: boolean, createdById: string, createdAt: any, createdBy: { __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string }, individuals: Array<{ __typename?: 'Individual', id: number, createdOn: any, createdBy: { __typename?: 'ApplicationUser', firstName: string, lastName: string, displayName: string }, customFieldValues: Array<{ __typename?: 'CustomFieldValue', fieldId: number, id: number, stringValue?: string | null, numericalValue?: any | null, dateValue?: any | null, displayString: string, field: { __typename?: 'CustomField', id: number, systemFieldId?: SystemFieldId | null, fieldType: CustomFieldType }, selectionValues: Array<{ __typename?: 'CustomFieldOption', id: number }>, lookupUserValues: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string }>, lookupTeamValue?: { __typename?: 'Team', id: number, name: string, description: string, isDefault: boolean } | null }> }>, unknownGroups: Array<{ __typename?: 'UnknownGroup', id: number, activityId: number, averageAge: any, numberOfUsers: any, gender?: string | null, customFieldValues: Array<{ __typename?: 'CustomFieldValue', fieldId: number, id: number, stringValue?: string | null, numericalValue?: any | null, dateValue?: any | null, displayString: string, field: { __typename?: 'CustomField', id: number, systemFieldId?: SystemFieldId | null, fieldType: CustomFieldType }, selectionValues: Array<{ __typename?: 'CustomFieldOption', id: number }>, lookupUserValues: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string }>, lookupTeamValue?: { __typename?: 'Team', id: number, name: string, description: string, isDefault: boolean } | null }> }>, realities: Array<{ __typename?: 'Reality', id: number, themeId: number, specificationId: number, values: Array<{ __typename?: 'CustomFieldValue', fieldId: number, id: number, stringValue?: string | null, numericalValue?: any | null, dateValue?: any | null, displayString: string, field: { __typename?: 'CustomField', id: number, systemFieldId?: SystemFieldId | null, fieldType: CustomFieldType }, selectionValues: Array<{ __typename?: 'CustomFieldOption', id: number }>, lookupUserValues: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string }>, lookupTeamValue?: { __typename?: 'Team', id: number, name: string, description: string, isDefault: boolean } | null }> }>, customFieldValues: Array<{ __typename?: 'CustomFieldValue', fieldId: number, id: number, stringValue?: string | null, numericalValue?: any | null, dateValue?: any | null, displayString: string, field: { __typename?: 'CustomField', id: number, systemFieldId?: SystemFieldId | null, fieldType: CustomFieldType }, selectionValues: Array<{ __typename?: 'CustomFieldOption', id: number }>, lookupUserValues: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string }>, lookupTeamValue?: { __typename?: 'Team', id: number, name: string, description: string, isDefault: boolean } | null }>, distributions: Array<{ __typename?: 'DistributionValue', itemId: number, distributedAmount: number }> }> };

export type GetDistributionItemsByIdsQueryVariables = Exact<{
  itemIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type GetDistributionItemsByIdsQuery = { __typename?: 'Query', items: Array<{ __typename?: 'DistributionItemDto', id: number, name: string, description: string, unit: string }> };

export type GetIndividualsSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIndividualsSettingsQuery = { __typename?: 'Query', settings: Array<{ __typename?: 'Setting', isKnownIndividualsEnabled: boolean }> };

export type GetOptionsBySystemFieldIdQueryVariables = Exact<{
  systemFieldId?: InputMaybe<SystemFieldId>;
}>;


export type GetOptionsBySystemFieldIdQuery = { __typename?: 'Query', options: Array<{ __typename?: 'CustomFieldOptionDto', id: number, name: string, order: number, customFieldId: number }> };

export type RealitiesDataQueryVariables = Exact<{ [key: string]: never; }>;


export type RealitiesDataQuery = { __typename?: 'Query', themes: Array<{ __typename?: 'RealityThemeDto', id: number, name: string, description: string, specifications: Array<{ __typename?: 'RealitySpecificationDto', id: number, name: string }> }>, accompaniments: Array<{ __typename?: 'CustomFieldOptionDto', id: number, name: string, isSystemOption: boolean }>, referrals: Array<{ __typename?: 'CustomFieldOptionDto', id: number, name: string, isSystemOption: boolean }>, approaches: Array<{ __typename?: 'CustomFieldOptionDto', id: number, name: string, isSystemOption: boolean }> };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', me: { __typename?: 'ApplicationUser', id: string, displayName: string, status: UserStatusType, teams: Array<{ __typename?: 'Team', id: number, name: string }>, roles: Array<{ __typename?: 'ApplicationRole', name: string, normalizedName: string }> } };

export type AddCustomPropertyMutationVariables = Exact<{
  input: AddCustomPropertyInput;
}>;


export type AddCustomPropertyMutation = { __typename?: 'Mutation', addCustomProperty: { __typename?: 'AddCustomPropertyPayload', customField?: { __typename?: 'CustomField', id: number } | null, errors?: Array<{ __typename?: 'DuplicateNameError', message: string } | { __typename?: 'ValidationResultError', message: string }> | null } };

export type AddExistingCustomFieldMutationVariables = Exact<{
  input: AddFieldToEntityTypeInput;
}>;


export type AddExistingCustomFieldMutation = { __typename?: 'Mutation', addFieldToEntityType: { __typename?: 'AddFieldToEntityTypePayload', errors?: Array<{ __typename?: 'ValidationResultError', message: string }> | null } };

export type AddSectionMutationVariables = Exact<{
  input: AddSectionInput;
}>;


export type AddSectionMutation = { __typename?: 'Mutation', addSection: { __typename?: 'AddSectionPayload', errors?: Array<{ __typename?: 'DuplicateNameError', message: string } | { __typename?: 'ValidationResultError', message: string }> | null } };

export type DeleteCustomFieldMutationVariables = Exact<{
  input: DeleteCustomFieldInput;
}>;


export type DeleteCustomFieldMutation = { __typename?: 'Mutation', deleteCustomField: { __typename?: 'DeleteCustomFieldPayload', errors?: Array<{ __typename?: 'NotFoundError', message: string } | { __typename?: 'ValidationResultError', message: string }> | null } };

export type DeleteSectionMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteSectionMutation = { __typename?: 'Mutation', deleteSection: { __typename?: 'DeleteSectionPayload', errors?: Array<{ __typename?: 'NotFoundError', message: string } | { __typename?: 'ValidationError', message: string }> | null } };

export type EditSectionMutationVariables = Exact<{
  input: EditSectionInput;
}>;


export type EditSectionMutation = { __typename?: 'Mutation', editSection: { __typename?: 'EditSectionPayload', errors?: Array<{ __typename?: 'DuplicateNameError', message: string } | { __typename?: 'ValidationResultError', message: string }> | null } };

export type ReorderFieldsMutationVariables = Exact<{
  input: ReorderFieldsInput;
}>;


export type ReorderFieldsMutation = { __typename?: 'Mutation', reorderFields: { __typename?: 'ReorderFieldsPayload', errors?: Array<{ __typename?: 'DuplicateNameError', message: string } | { __typename?: 'ValidationResultError', message: string }> | null } };

export type UpdateCustomPropertyMutationVariables = Exact<{
  input: EditCustomPropertyInput;
}>;


export type UpdateCustomPropertyMutation = { __typename?: 'Mutation', editCustomProperty: { __typename?: 'EditCustomPropertyPayload', errors?: Array<{ __typename?: 'DuplicateNameError', message: string } | { __typename?: 'NotFoundError', message: string } | { __typename?: 'ValidationResultError', message: string }> | null } };

export type FindCustomFieldsQueryVariables = Exact<{
  filter?: InputMaybe<CustomFieldDtoFilterInput>;
}>;


export type FindCustomFieldsQuery = { __typename?: 'Query', customFields: Array<{ __typename?: 'CustomFieldDto', id: number, customFieldType: CustomFieldType, isSystemField: boolean, name: string, description?: string | null, status: CustomFieldStatusType, isRequired: boolean, allowMultipleValues: boolean, numberOfLines: number, systemFieldId?: SystemFieldId | null, entityTypes: Array<{ __typename?: 'CustomFieldEntityType', id: number, order: number, entityType: EntityType, sectionId: number }>, options: Array<{ __typename?: 'CustomFieldOptionDto', id: number, name: string, order: number, customFieldId: number }> }> };

export type FindSectionsQueryVariables = Exact<{
  filter?: InputMaybe<FieldSectionDtoFilterInput>;
}>;


export type FindSectionsQuery = { __typename?: 'Query', sections: Array<{ __typename?: 'FieldSectionDto', id: number, name: string, order: number, fieldEntityTypes: Array<{ __typename?: 'CustomFieldEntityType', id: number, order: number, sectionId: number, entityType: EntityType, customFieldId: number, customFieldDto: { __typename?: 'CustomFieldDto', id: number, customFieldType: CustomFieldType, isSystemField: boolean, systemFieldId?: SystemFieldId | null, allowMultipleValues: boolean, numberOfLines: number, name: string, description?: string | null, status: CustomFieldStatusType, isRequired: boolean, options: Array<{ __typename?: 'CustomFieldOptionDto', id: number, name: string, order: number, customFieldId: number, isSystemOption: boolean }> } }> }> };

export type GetOptionsByCustomFieldIdQueryVariables = Exact<{
  customFieldId?: InputMaybe<Scalars['Int']>;
}>;


export type GetOptionsByCustomFieldIdQuery = { __typename?: 'Query', options: Array<{ __typename?: 'CustomFieldOptionDto', id: number, name: string, order: number, customFieldId: number, isSystemOption: boolean }> };

export type CustomFieldAddedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type CustomFieldAddedSubscription = { __typename?: 'Subscription', customFieldAdded: { __typename?: 'CustomField', id: number } };

export type CustomFieldUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type CustomFieldUpdatedSubscription = { __typename?: 'Subscription', customFieldUpdated: { __typename?: 'CustomField', id: number } };

export type AddDistrubtionCategoryMutationVariables = Exact<{
  input: AddDistributionCategoryInput;
}>;


export type AddDistrubtionCategoryMutation = { __typename?: 'Mutation', addDistributionCategory: { __typename?: 'AddDistributionCategoryPayload', errors?: Array<{ __typename?: 'ValidationResultError', message: string }> | null } };

export type EditDistrubtionCategoryMutationVariables = Exact<{
  input: EditDistributionCategoryInput;
}>;


export type EditDistrubtionCategoryMutation = { __typename?: 'Mutation', editDistributionCategory: { __typename?: 'EditDistributionCategoryPayload', errors?: Array<{ __typename?: 'NotFoundError', message: string } | { __typename?: 'ValidationResultError', message: string }> | null } };

export type DeleteDistributionCategoryMutationVariables = Exact<{
  input: DeleteDistributionCategoryInput;
}>;


export type DeleteDistributionCategoryMutation = { __typename?: 'Mutation', deleteDistributionCategory: { __typename?: 'DeleteDistributionCategoryPayload', errors?: Array<{ __typename?: 'NotFoundError', message: string }> | null } };

export type AddDistrubtionItemMutationVariables = Exact<{
  input: AddDistributionItemInput;
}>;


export type AddDistrubtionItemMutation = { __typename?: 'Mutation', addDistributionItem: { __typename?: 'AddDistributionItemPayload', errors?: Array<{ __typename?: 'ValidationResultError', message: string }> | null } };

export type EditDistrubtionItemMutationVariables = Exact<{
  input: EditDistributionItemInput;
}>;


export type EditDistrubtionItemMutation = { __typename?: 'Mutation', editDistributionItem: { __typename?: 'EditDistributionItemPayload', errors?: Array<{ __typename?: 'NotFoundError', message: string } | { __typename?: 'ValidationResultError', message: string }> | null } };

export type DeleteDistributionItemMutationVariables = Exact<{
  input: DeleteDistributionItemInput;
}>;


export type DeleteDistributionItemMutation = { __typename?: 'Mutation', deleteDistributionItem: { __typename?: 'DeleteDistributionItemPayload', errors?: Array<{ __typename?: 'NotFoundError', message: string }> | null } };

export type ReorderDistributionCategoriesMutationVariables = Exact<{
  input: ReorderDistributionCategoriesInput;
}>;


export type ReorderDistributionCategoriesMutation = { __typename?: 'Mutation', reorderDistributionCategories: { __typename?: 'ReorderDistributionCategoriesPayload', errors?: Array<{ __typename?: 'ValidationResultError', message: string }> | null } };

export type FindDistributionCategoriesQueryVariables = Exact<{
  input?: InputMaybe<DistributionCategoryDtoFilterInput>;
}>;


export type FindDistributionCategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'DistributionCategoryDto', id: number, name: string }> };

export type FindDistributionItemsQueryVariables = Exact<{
  filter?: InputMaybe<DistributionItemDtoFilterInput>;
}>;


export type FindDistributionItemsQuery = { __typename?: 'Query', items: Array<{ __typename?: 'DistributionItemDto', id: number, name: string, description: string, unit: string, isDisabled: boolean, categoryIds: Array<number> }> };

export type GetActivitiesByTypeInDateRangeQueryVariables = Exact<{
  min: Scalars['DateTime'];
  max: Scalars['DateTime'];
  createdBy: Scalars['String'];
  teamsId: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type GetActivitiesByTypeInDateRangeQuery = { __typename?: 'Query', activitiesCountByType: Array<{ __typename?: 'ActivitiesCountByType', activityType: ActivityType, count: number }> };

export type GetActivitiesCountByDateInDateRangeQueryVariables = Exact<{
  min: Scalars['DateTime'];
  max: Scalars['DateTime'];
  createdBy: Scalars['String'];
  teamsId: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type GetActivitiesCountByDateInDateRangeQuery = { __typename?: 'Query', activitiesCountByDate: Array<{ __typename?: 'ActivitiesCountByDate', activityType: ActivityType, date: any, count: number }> };

export type GetIndividualsCountByGenderQueryVariables = Exact<{
  min: Scalars['DateTime'];
  max: Scalars['DateTime'];
  createdBy: Scalars['String'];
  teamsId: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type GetIndividualsCountByGenderQuery = { __typename?: 'Query', individualsCountByGender: Array<{ __typename?: 'IndividualsByGender', gender: string, count: any }> };

export type GetLatestActivitiesQueryVariables = Exact<{
  min: Scalars['DateTime'];
  max: Scalars['DateTime'];
  createdBy: Scalars['String'];
  teamsId: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type GetLatestActivitiesQuery = { __typename?: 'Query', latestActivities: Array<{ __typename?: 'Activity', id: number, type: ActivityType, createdAt: any, customFieldValues: Array<{ __typename?: 'CustomFieldValue', fieldId: number, id: number, stringValue?: string | null, numericalValue?: any | null, dateValue?: any | null, displayString: string, field: { __typename?: 'CustomField', id: number, systemFieldId?: SystemFieldId | null, fieldType: CustomFieldType }, selectionValues: Array<{ __typename?: 'CustomFieldOption', id: number }>, lookupUserValues: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string }>, lookupTeamValue?: { __typename?: 'Team', id: number, name: string, description: string, isDefault: boolean } | null }> }> };

export type GetLatestIndividualsQueryVariables = Exact<{
  min: Scalars['DateTime'];
  max: Scalars['DateTime'];
  createdBy: Scalars['String'];
  teamsId: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type GetLatestIndividualsQuery = { __typename?: 'Query', latestIndividuals: Array<{ __typename?: 'LatestIndividuals', id: number, activityDate: any, nickname: string, birthday: any, genderId: number }> };

export type GetOptionsbySystemFieldIdQueryVariables = Exact<{
  systemFieldId?: InputMaybe<SystemFieldId>;
}>;


export type GetOptionsbySystemFieldIdQuery = { __typename?: 'Query', options: Array<{ __typename?: 'CustomFieldOptionDto', id: number, name: string }> };

export type GetTeamsActivitiesCountQueryVariables = Exact<{
  min: Scalars['DateTime'];
  max: Scalars['DateTime'];
  createdBy: Scalars['String'];
  teamsId: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type GetTeamsActivitiesCountQuery = { __typename?: 'Query', activitiesCountByTeam: Array<{ __typename?: 'TeamStat', id: string, name: string, teamId: number, teamName: string, lastActivityDate: any, distributions: number, interventions: number, meetings: number, presentations: number, routines: number }> };

export type GetTopDistributedItemsQueryVariables = Exact<{
  min: Scalars['DateTime'];
  max: Scalars['DateTime'];
  createdBy: Scalars['String'];
  teamsId: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type GetTopDistributedItemsQuery = { __typename?: 'Query', topDistributedItems: Array<{ __typename?: 'DistributedItems', id: number, quantity: number, name: string }> };

export type AddIndividualMutationVariables = Exact<{
  input: AddIndividualInput;
}>;


export type AddIndividualMutation = { __typename?: 'Mutation', addIndividual: { __typename?: 'AddIndividualPayload', individual?: { __typename?: 'Individual', id: number } | null, errors?: Array<{ __typename?: 'ValidationResultError', message: string }> | null } };

export type DeleteIndividualMutationVariables = Exact<{
  input: DeleteIndividualInput;
}>;


export type DeleteIndividualMutation = { __typename?: 'Mutation', deleteIndividual: { __typename?: 'DeleteIndividualPayload', individual?: { __typename?: 'Individual', id: number } | null, errors?: Array<{ __typename?: 'NotFoundError', message: string } | { __typename?: 'ValidationResultError', message: string }> | null } };

export type EditIndividualMutationVariables = Exact<{
  input: EditIndividualInput;
}>;


export type EditIndividualMutation = { __typename?: 'Mutation', editIndividual: { __typename?: 'EditIndividualPayload', individual?: { __typename?: 'Individual', id: number } | null, errors?: Array<{ __typename?: 'ValidationResultError', message: string }> | null } };

export type MergeIndividualsMutationVariables = Exact<{
  input: MergeIndividualsInput;
}>;


export type MergeIndividualsMutation = { __typename?: 'Mutation', mergeIndividuals: { __typename?: 'MergeIndividualsPayload', individual?: { __typename?: 'Individual', id: number } | null, errors?: Array<{ __typename?: 'NotFoundError', message: string } | { __typename?: 'ValidationResultError', message: string }> | null } };

export type RestoreIndividualMutationVariables = Exact<{
  input: RestoreIndividualInput;
}>;


export type RestoreIndividualMutation = { __typename?: 'Mutation', restoreIndividual: { __typename?: 'RestoreIndividualPayload', individual?: { __typename?: 'Individual', id: number } | null, errors?: Array<{ __typename?: 'NotFoundError', message: string } | { __typename?: 'ValidationResultError', message: string }> | null } };

export type FindDeletedIndividualsQueryVariables = Exact<{
  filter?: InputMaybe<IndividualFilterInput>;
}>;


export type FindDeletedIndividualsQuery = { __typename?: 'Query', deletedIndividuals: Array<{ __typename?: 'Individual', id: number, createdOn: any, nickName?: string | null, birthday?: string | null, gender?: string | null, isDeleted: boolean, customFieldValues: Array<{ __typename?: 'CustomFieldValue', fieldId: number, id: number, stringValue?: string | null, numericalValue?: any | null, dateValue?: any | null, displayString: string, field: { __typename?: 'CustomField', id: number, systemFieldId?: SystemFieldId | null, fieldType: CustomFieldType }, selectionValues: Array<{ __typename?: 'CustomFieldOption', id: number }>, lookupUserValues: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string }>, lookupTeamValue?: { __typename?: 'Team', id: number, name: string, description: string, isDefault: boolean } | null }> }> };

export type FindIndividualsQueryVariables = Exact<{
  input?: InputMaybe<IndividualFilterInput>;
  searchTerm: Scalars['String'];
  pageSize: Scalars['Int'];
  skip: Scalars['Int'];
  showDeleted?: InputMaybe<Scalars['Boolean']>;
}>;


export type FindIndividualsQuery = { __typename?: 'Query', searchIndividuals?: { __typename?: 'SearchIndividualsCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'Individual', id: number, nickName?: string | null, birthday?: string | null, gender?: string | null, customFieldValues: Array<{ __typename?: 'CustomFieldValue', fieldId: number, id: number, stringValue?: string | null, numericalValue?: any | null, dateValue?: any | null, displayString: string, field: { __typename?: 'CustomField', id: number, systemFieldId?: SystemFieldId | null, fieldType: CustomFieldType }, selectionValues: Array<{ __typename?: 'CustomFieldOption', id: number }>, lookupUserValues: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string }>, lookupTeamValue?: { __typename?: 'Team', id: number, name: string, description: string, isDefault: boolean } | null }> }> | null } | null };

export type AddTenantMutationVariables = Exact<{
  input: AddTenantInput;
}>;


export type AddTenantMutation = { __typename?: 'Mutation', addTenant: { __typename?: 'AddTenantPayload', tenant?: { __typename?: 'Tenant', id?: string | null } | null, errors?: Array<{ __typename?: 'DuplicateNameError', message: string } | { __typename?: 'MissingConfigurationError', message: string } | { __typename?: 'ValidationResultError', message: string }> | null } };

export type EditTenantMutationVariables = Exact<{
  input: EditTenantInput;
}>;


export type EditTenantMutation = { __typename?: 'Mutation', editTenant: { __typename?: 'EditTenantPayload', tenant?: { __typename?: 'Tenant', id?: string | null } | null, errors?: Array<{ __typename?: 'ValidationResultError', message: string }> | null } };

export type FindTenantsQueryVariables = Exact<{
  filter?: InputMaybe<TenantFilterInput>;
}>;


export type FindTenantsQuery = { __typename?: 'Query', tenants: Array<{ __typename?: 'Tenant', id?: string | null, name?: string | null, region?: string | null, town?: string | null, isProvisioned: boolean, isIncludedInGlobalReport: boolean }> };

export type GetTenantByIdQueryVariables = Exact<{
  tenantId: Scalars['String'];
}>;


export type GetTenantByIdQuery = { __typename?: 'Query', tenants: Array<{ __typename?: 'Tenant', id?: string | null, name?: string | null, identifier?: string | null, region?: string | null, town?: string | null, telephone?: string | null, extensionTelephone?: string | null, email?: string | null, isIncludedInGlobalReport: boolean }> };

export type EditSpecificationsMutationVariables = Exact<{
  input: EditSpecificationsInput;
}>;


export type EditSpecificationsMutation = { __typename?: 'Mutation', editSpecifications: { __typename?: 'EditSpecificationsPayload', errors?: Array<{ __typename?: 'DuplicateNameError', message: string } | { __typename?: 'ValidationResultError', message: string }> | null } };

export type FindThemesWithSpecificationsQueryVariables = Exact<{
  filter?: InputMaybe<RealityThemeDtoFilterInput>;
}>;


export type FindThemesWithSpecificationsQuery = { __typename?: 'Query', themes: Array<{ __typename?: 'RealityThemeDto', id: number, name: string, specifications: Array<{ __typename?: 'RealitySpecificationDto', id: number, name: string }> }> };

export type AddReportModelMutationVariables = Exact<{
  input: AddReportModelInput;
}>;


export type AddReportModelMutation = { __typename?: 'Mutation', addReportModel: { __typename?: 'AddReportModelPayload', report?: { __typename?: 'Report', id: number, name: string, lastUpdated: any, reportValues: { __typename?: 'ReportParameters', ageGroupBoundaries: Array<number>, genderBreakdown: ReportGenderBreakdown, includeUnknownIndividuals: boolean, fieldsVisibility?: { __typename?: 'ReportFieldsVisibility', visibleCustomFieldIds?: Array<number> | null, areThemesVisible: boolean, areSpecificationsVisible: boolean, areActivityTypesVisible: boolean, areDistributionsVisible: boolean } | null, filters: { __typename?: 'ReportFilterValues', activityTypes: Array<ActivityType>, themeIds: Array<number>, specificationIds: Array<number>, itemIds: Array<number>, categoryIds: Array<number>, useOutreachWorkersOrLogic: boolean, period: { __typename?: 'PeriodFilter', from: any, to: any }, distributedAmounts?: { __typename?: 'NumericalFilter', min?: number | null, max?: number | null } | null, customFieldFilters: Array<{ __typename?: 'ReportFieldFilter', customFieldId: number, numericalFilter?: { __typename?: 'NumericalFilter', min?: number | null, max?: number | null } | null, dateFilter?: { __typename?: 'DateFilter', from?: any | null, to?: any | null } | null, selectionFilter?: { __typename?: 'SelectionFilter', optionIds: Array<number> } | null, lookupFilter?: { __typename?: 'LookupFilter', userIds?: Array<string> | null, teamIds?: Array<number> | null } | null }>, individualsFieldFilters: Array<{ __typename?: 'ReportFieldFilter', customFieldId: number, numericalFilter?: { __typename?: 'NumericalFilter', min?: number | null, max?: number | null } | null, dateFilter?: { __typename?: 'DateFilter', from?: any | null, to?: any | null } | null, selectionFilter?: { __typename?: 'SelectionFilter', optionIds: Array<number> } | null, lookupFilter?: { __typename?: 'LookupFilter', userIds?: Array<string> | null, teamIds?: Array<number> | null } | null }>, unknownGroupFieldFilters: Array<{ __typename?: 'ReportFieldFilter', customFieldId: number, numericalFilter?: { __typename?: 'NumericalFilter', min?: number | null, max?: number | null } | null, dateFilter?: { __typename?: 'DateFilter', from?: any | null, to?: any | null } | null, selectionFilter?: { __typename?: 'SelectionFilter', optionIds: Array<number> } | null, lookupFilter?: { __typename?: 'LookupFilter', userIds?: Array<string> | null, teamIds?: Array<number> | null } | null }>, realitiesFieldFilters: Array<{ __typename?: 'ReportFieldFilter', customFieldId: number, numericalFilter?: { __typename?: 'NumericalFilter', min?: number | null, max?: number | null } | null, dateFilter?: { __typename?: 'DateFilter', from?: any | null, to?: any | null } | null, selectionFilter?: { __typename?: 'SelectionFilter', optionIds: Array<number> } | null, lookupFilter?: { __typename?: 'LookupFilter', userIds?: Array<string> | null, teamIds?: Array<number> | null } | null }> } } } | null } };

export type DeleteModelMutationVariables = Exact<{
  input: DeleteReportModelInput;
}>;


export type DeleteModelMutation = { __typename?: 'Mutation', deleteReportModel: { __typename?: 'DeleteReportModelPayload', errors?: Array<{ __typename?: 'NotFoundError', message: string } | { __typename?: 'ValidationResultError', message: string }> | null } };

export type EditReportModelMutationVariables = Exact<{
  input: EditReportModelInput;
}>;


export type EditReportModelMutation = { __typename?: 'Mutation', editReportModel: { __typename?: 'EditReportModelPayload', report?: { __typename?: 'Report', id: number } | null } };

export type GetModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetModelsQuery = { __typename?: 'Query', models: Array<{ __typename?: 'Report', id: number, name: string, lastUpdated: any, reportValues: { __typename?: 'ReportParameters', ageGroupBoundaries: Array<number>, genderBreakdown: ReportGenderBreakdown, includeUnknownIndividuals: boolean, fieldsVisibility?: { __typename?: 'ReportFieldsVisibility', visibleCustomFieldIds?: Array<number> | null, areThemesVisible: boolean, areSpecificationsVisible: boolean, areActivityTypesVisible: boolean, areDistributionsVisible: boolean } | null, filters: { __typename?: 'ReportFilterValues', activityTypes: Array<ActivityType>, themeIds: Array<number>, specificationIds: Array<number>, itemIds: Array<number>, categoryIds: Array<number>, useOutreachWorkersOrLogic: boolean, period: { __typename?: 'PeriodFilter', from: any, to: any }, distributedAmounts?: { __typename?: 'NumericalFilter', min?: number | null, max?: number | null } | null, customFieldFilters: Array<{ __typename?: 'ReportFieldFilter', customFieldId: number, numericalFilter?: { __typename?: 'NumericalFilter', min?: number | null, max?: number | null } | null, dateFilter?: { __typename?: 'DateFilter', from?: any | null, to?: any | null } | null, selectionFilter?: { __typename?: 'SelectionFilter', optionIds: Array<number> } | null, lookupFilter?: { __typename?: 'LookupFilter', userIds?: Array<string> | null, teamIds?: Array<number> | null } | null }>, individualsFieldFilters: Array<{ __typename?: 'ReportFieldFilter', customFieldId: number, numericalFilter?: { __typename?: 'NumericalFilter', min?: number | null, max?: number | null } | null, dateFilter?: { __typename?: 'DateFilter', from?: any | null, to?: any | null } | null, selectionFilter?: { __typename?: 'SelectionFilter', optionIds: Array<number> } | null, lookupFilter?: { __typename?: 'LookupFilter', userIds?: Array<string> | null, teamIds?: Array<number> | null } | null }>, unknownGroupFieldFilters: Array<{ __typename?: 'ReportFieldFilter', customFieldId: number, numericalFilter?: { __typename?: 'NumericalFilter', min?: number | null, max?: number | null } | null, dateFilter?: { __typename?: 'DateFilter', from?: any | null, to?: any | null } | null, selectionFilter?: { __typename?: 'SelectionFilter', optionIds: Array<number> } | null, lookupFilter?: { __typename?: 'LookupFilter', userIds?: Array<string> | null, teamIds?: Array<number> | null } | null }>, realitiesFieldFilters: Array<{ __typename?: 'ReportFieldFilter', customFieldId: number, numericalFilter?: { __typename?: 'NumericalFilter', min?: number | null, max?: number | null } | null, dateFilter?: { __typename?: 'DateFilter', from?: any | null, to?: any | null } | null, selectionFilter?: { __typename?: 'SelectionFilter', optionIds: Array<number> } | null, lookupFilter?: { __typename?: 'LookupFilter', userIds?: Array<string> | null, teamIds?: Array<number> | null } | null }> } } }> };

export type GetReportCountQueryVariables = Exact<{
  input: ReportParametersInput;
}>;


export type GetReportCountQuery = { __typename?: 'Query', reportCount: { __typename?: 'ReportCountValues', activitiesCount: number, individualsCount: number } };

export type ReportFieldFilterFragmentFragment = { __typename?: 'ReportFieldFilter', customFieldId: number, numericalFilter?: { __typename?: 'NumericalFilter', min?: number | null, max?: number | null } | null, dateFilter?: { __typename?: 'DateFilter', from?: any | null, to?: any | null } | null, selectionFilter?: { __typename?: 'SelectionFilter', optionIds: Array<number> } | null, lookupFilter?: { __typename?: 'LookupFilter', userIds?: Array<string> | null, teamIds?: Array<number> | null } | null };

export type EditSettingsMutationVariables = Exact<{
  input: EditSettingsInput;
}>;


export type EditSettingsMutation = { __typename?: 'Mutation', editSettings: { __typename?: 'EditSettingsPayload', setting?: { __typename?: 'Setting', isKnownIndividualsEnabled: boolean, activityEditDelayDays: number } | null, errors?: Array<{ __typename?: 'NotFoundError', message: string } | { __typename?: 'ValidationError', message: string }> | null } };

export type GetSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSettingsQuery = { __typename?: 'Query', settings: Array<{ __typename?: 'Setting', isKnownIndividualsEnabled: boolean, isDistributionEnabled: boolean, isInterventionEnabled: boolean, isMeetingEnabled: boolean, isPresentationEnabled: boolean, isRoutineEnabled: boolean, activityEditDelayDays: number, fiscalYearStart?: any | null }> };

export type AddTeamMutationVariables = Exact<{
  input: AddTeamInput;
}>;


export type AddTeamMutation = { __typename?: 'Mutation', addTeam: { __typename?: 'AddTeamPayload', team?: { __typename?: 'Team', id: number } | null, errors?: Array<{ __typename?: 'DuplicateNameError', message: string } | { __typename?: 'ValidationResultError', message: string }> | null } };

export type AddTeamMembersMutationVariables = Exact<{
  input: AddTeamMembersInput;
}>;


export type AddTeamMembersMutation = { __typename?: 'Mutation', addTeamMembers: { __typename?: 'AddTeamMembersPayload', team?: { __typename?: 'Team', id: number } | null, errors?: Array<{ __typename?: 'NotFoundError', message: string } | { __typename?: 'ValidationResultError', message: string }> | null } };

export type DeleteTeamMutationVariables = Exact<{
  input: DeleteTeamInput;
}>;


export type DeleteTeamMutation = { __typename?: 'Mutation', deleteTeam: { __typename?: 'DeleteTeamPayload', errors?: Array<{ __typename?: 'NotFoundError', message: string }> | null } };

export type EditTeamMutationVariables = Exact<{
  input: EditTeamInput;
}>;


export type EditTeamMutation = { __typename?: 'Mutation', editTeam: { __typename?: 'EditTeamPayload', team?: { __typename?: 'Team', id: number } | null, errors?: Array<{ __typename?: 'NotFoundError', message: string } | { __typename?: 'ValidationResultError', message: string }> | null } };

export type RemoveTeamMemberMutationVariables = Exact<{
  input: RemoveTeamMemberInput;
}>;


export type RemoveTeamMemberMutation = { __typename?: 'Mutation', removeTeamMember: { __typename?: 'RemoveTeamMemberPayload', team?: { __typename?: 'Team', id: number } | null, errors?: Array<{ __typename?: 'NotFoundError', message: string } | { __typename?: 'ValidationResultError', message: string }> | null } };

export type FindTeamsQueryVariables = Exact<{
  filter?: InputMaybe<TeamFilterInput>;
}>;


export type FindTeamsQuery = { __typename?: 'Query', teams: Array<{ __typename?: 'Team', id: number, name: string, description: string, members: Array<{ __typename?: 'ApplicationUser', id: string, displayName: string, firstName: string, lastName: string, status: UserStatusType }> }> };

export type GetTeamByIdQueryVariables = Exact<{
  teamId: Scalars['Int'];
}>;


export type GetTeamByIdQuery = { __typename?: 'Query', teams: Array<{ __typename?: 'Team', id: number, name: string, description: string, isDefault: boolean, members: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string, email?: string | null, status: UserStatusType, roles: Array<{ __typename?: 'ApplicationRole', name: string, normalizedName: string }>, teams: Array<{ __typename?: 'Team', id: number, description: string, name: string }> }> }> };

export type DeactivateUserMutationVariables = Exact<{
  input: DeactivateUserInput;
}>;


export type DeactivateUserMutation = { __typename?: 'Mutation', deactivateUser: { __typename?: 'DeactivateUserPayload', string?: string | null, errors?: Array<{ __typename?: 'NotFoundError', message: string } | { __typename?: 'ValidationResultError', message: string }> | null } };

export type EditUserDetailsMutationVariables = Exact<{
  input: EditUserDetailsInput;
}>;


export type EditUserDetailsMutation = { __typename?: 'Mutation', editUserDetails: { __typename?: 'EditUserDetailsPayload', errors?: Array<{ __typename?: 'NotFoundError', message: string } | { __typename?: 'ValidationResultError', message: string }> | null } };

export type InviteUserMutationVariables = Exact<{
  input: InviteUserInput;
  tenantId?: InputMaybe<Scalars['String']>;
}>;


export type InviteUserMutation = { __typename?: 'Mutation', inviteUser: { __typename?: 'InviteUserPayload', applicationUser?: { __typename?: 'ApplicationUser', id: string } | null, errors?: Array<{ __typename?: 'IdentityResultError', message: string } | { __typename?: 'ValidationError', message: string }> | null } };

export type ModifyUserTeamsMutationVariables = Exact<{
  input: ModifyUserTeamsInput;
}>;


export type ModifyUserTeamsMutation = { __typename?: 'Mutation', modifyUserTeams: { __typename?: 'ModifyUserTeamsPayload', applicationUser?: { __typename?: 'ApplicationUser', id: string } | null, errors?: Array<{ __typename?: 'NotFoundError', message: string } | { __typename?: 'ValidationResultError', message: string }> | null } };

export type UpdateRoleMutationVariables = Exact<{
  input: UpdateUserRoleInput;
}>;


export type UpdateRoleMutation = { __typename?: 'Mutation', updateUserRole: { __typename?: 'UpdateUserRolePayload', errors?: Array<{ __typename?: 'IdentityResultError', message: string } | { __typename?: 'ValidationError', message: string }> | null } };

export type FindAllUsersQueryVariables = Exact<{
  filter?: InputMaybe<ApplicationUserFilterInput>;
}>;


export type FindAllUsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string, email?: string | null }> };

export type FindUsersQueryVariables = Exact<{
  filter?: InputMaybe<ApplicationUserFilterInput>;
}>;


export type FindUsersQuery = { __typename?: 'Query', activeUsers: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string, email?: string | null, status: UserStatusType, roles: Array<{ __typename?: 'ApplicationRole', name: string, normalizedName: string }>, teams: Array<{ __typename?: 'Team', id: number, name: string, description: string, isDefault: boolean }> }> };

export type FindUsersByTenantQueryVariables = Exact<{
  tenantId: Scalars['String'];
  filter?: InputMaybe<ApplicationUserFilterInput>;
}>;


export type FindUsersByTenantQuery = { __typename?: 'Query', usersByTenant: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string, status: UserStatusType, roles: Array<{ __typename?: 'ApplicationRole', name: string, normalizedName: string }>, teams: Array<{ __typename?: 'Team', id: number, name: string, description: string, isDefault: boolean }> }> };

export type GetUserByIdQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetUserByIdQuery = { __typename?: 'Query', activeUsers: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, displayName: string, status: UserStatusType, email?: string | null, roles: Array<{ __typename?: 'ApplicationRole', name: string, normalizedName: string }>, teams: Array<{ __typename?: 'Team', id: number, name: string, description: string, isDefault: boolean }> }> };

export const CustomFieldValueFragmentFragmentDoc = `
    fragment CustomFieldValueFragment on CustomFieldValue {
  fieldId
  field {
    id
    systemFieldId
    fieldType
  }
  id
  selectionValues {
    id
  }
  stringValue
  numericalValue
  dateValue
  lookupUserValues {
    id
    firstName
    lastName
    displayName
  }
  lookupTeamValue {
    id
    name
    description
    isDefault
  }
  displayString
}
    `;
export const ReportFieldFilterFragmentFragmentDoc = `
    fragment ReportFieldFilterFragment on ReportFieldFilter {
  customFieldId
  numericalFilter {
    min
    max
  }
  dateFilter {
    from
    to
  }
  selectionFilter {
    optionIds
  }
  lookupFilter {
    userIds
    teamIds
  }
}
    `;
export const AddActivityDocument = `
    mutation addActivity($input: AddActivityInput!) {
  addActivity(input: $input) {
    activity {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useAddActivityMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddActivityMutation, TError, AddActivityMutationVariables, TContext>) =>
    useMutation<AddActivityMutation, TError, AddActivityMutationVariables, TContext>(
      ['addActivity'],
      (variables?: AddActivityMutationVariables) => fetchData<AddActivityMutation, AddActivityMutationVariables>(AddActivityDocument, variables)(),
      options
    );
export const DeleteActivityDocument = `
    mutation deleteActivity($input: DeleteActivityInput!) {
  deleteActivity(input: $input) {
    activity {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useDeleteActivityMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteActivityMutation, TError, DeleteActivityMutationVariables, TContext>) =>
    useMutation<DeleteActivityMutation, TError, DeleteActivityMutationVariables, TContext>(
      ['deleteActivity'],
      (variables?: DeleteActivityMutationVariables) => fetchData<DeleteActivityMutation, DeleteActivityMutationVariables>(DeleteActivityDocument, variables)(),
      options
    );
export const EditActivityDocument = `
    mutation editActivity($input: EditActivityInput!) {
  editActivity(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useEditActivityMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditActivityMutation, TError, EditActivityMutationVariables, TContext>) =>
    useMutation<EditActivityMutation, TError, EditActivityMutationVariables, TContext>(
      ['editActivity'],
      (variables?: EditActivityMutationVariables) => fetchData<EditActivityMutation, EditActivityMutationVariables>(EditActivityDocument, variables)(),
      options
    );
export const RestoreActivityDocument = `
    mutation restoreActivity($input: RestoreActivityInput!) {
  restoreActivity(input: $input) {
    activity {
      id
    }
  }
}
    `;
export const useRestoreActivityMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RestoreActivityMutation, TError, RestoreActivityMutationVariables, TContext>) =>
    useMutation<RestoreActivityMutation, TError, RestoreActivityMutationVariables, TContext>(
      ['restoreActivity'],
      (variables?: RestoreActivityMutationVariables) => fetchData<RestoreActivityMutation, RestoreActivityMutationVariables>(RestoreActivityDocument, variables)(),
      options
    );
export const FindActivitiesDocument = `
    query findActivities($filter: ActivityFilterInput, $pageSize: Int!, $skip: Int!, $searchTerm: String, $includeIndividuals: Boolean = true, $includeUnknownGroups: Boolean = true, $includeRealities: Boolean = true, $filterValues: CustomFieldValueFilterInput, $filterIndividualValues: CustomFieldValueFilterInput, $filterUnknownGroupValues: CustomFieldValueFilterInput, $filterRealitiesValues: CustomFieldValueFilterInput) {
  activities(
    take: $pageSize
    skip: $skip
    where: $filter
    searchTerm: $searchTerm
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      type
      createdAt
      owningTeamId
      customFieldValues(where: $filterValues) {
        ...CustomFieldValueFragment
      }
      createdById
      isDeleted
      individuals @include(if: $includeIndividuals) {
        customFieldValues(where: $filterIndividualValues) {
          ...CustomFieldValueFragment
        }
      }
      unknownGroups @include(if: $includeUnknownGroups) {
        customFieldValues(where: $filterUnknownGroupValues) {
          ...CustomFieldValueFragment
        }
      }
      realities @include(if: $includeRealities) {
        themeId
        specificationId
        values(where: $filterRealitiesValues) {
          ...CustomFieldValueFragment
        }
      }
    }
  }
}
    ${CustomFieldValueFragmentFragmentDoc}`;
export const useFindActivitiesQuery = <
      TData = FindActivitiesQuery,
      TError = unknown
    >(
      variables: FindActivitiesQueryVariables,
      options?: UseQueryOptions<FindActivitiesQuery, TError, TData>
    ) =>
    useQuery<FindActivitiesQuery, TError, TData>(
      ['findActivities', variables],
      fetchData<FindActivitiesQuery, FindActivitiesQueryVariables>(FindActivitiesDocument, variables),
      options
    );
export const FindDeletedActivitiesDocument = `
    query findDeletedActivities($filter: ActivityFilterInput) {
  deletedActivities(where: $filter) {
    id
    type
    createdAt
    createdById
    owningTeamId
    isDeleted
    customFieldValues {
      ...CustomFieldValueFragment
    }
    distributions {
      itemId
    }
    individuals {
      customFieldValues {
        ...CustomFieldValueFragment
      }
    }
    unknownGroups {
      customFieldValues {
        ...CustomFieldValueFragment
      }
    }
    realities {
      themeId
      specificationId
      values {
        ...CustomFieldValueFragment
      }
    }
  }
}
    ${CustomFieldValueFragmentFragmentDoc}`;
export const useFindDeletedActivitiesQuery = <
      TData = FindDeletedActivitiesQuery,
      TError = unknown
    >(
      variables?: FindDeletedActivitiesQueryVariables,
      options?: UseQueryOptions<FindDeletedActivitiesQuery, TError, TData>
    ) =>
    useQuery<FindDeletedActivitiesQuery, TError, TData>(
      variables === undefined ? ['findDeletedActivities'] : ['findDeletedActivities', variables],
      fetchData<FindDeletedActivitiesQuery, FindDeletedActivitiesQueryVariables>(FindDeletedActivitiesDocument, variables),
      options
    );
export const FindMyTeamsActivitiesDocument = `
    query findMyTeamsActivities($filter: ActivityFilterInput, $pageSize: Int!, $skip: Int!) {
  myTeamsActivities(take: $pageSize, skip: $skip, where: $filter) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      type
      createdAt
      createdBy {
        firstName
        lastName
        displayName
      }
      customFieldValues {
        fieldId
        field {
          systemFieldId
        }
        id
        selectionValues {
          id
        }
        stringValue
        numericalValue
        dateValue
        displayString
      }
    }
  }
}
    `;
export const useFindMyTeamsActivitiesQuery = <
      TData = FindMyTeamsActivitiesQuery,
      TError = unknown
    >(
      variables: FindMyTeamsActivitiesQueryVariables,
      options?: UseQueryOptions<FindMyTeamsActivitiesQuery, TError, TData>
    ) =>
    useQuery<FindMyTeamsActivitiesQuery, TError, TData>(
      ['findMyTeamsActivities', variables],
      fetchData<FindMyTeamsActivitiesQuery, FindMyTeamsActivitiesQueryVariables>(FindMyTeamsActivitiesDocument, variables),
      options
    );
export const GetActivityByIdDocument = `
    query getActivityById($id: Int!) {
  activities(where: {id: {eq: $id}}) {
    items {
      id
      type
      owningTeamId
      createdBy {
        id
        firstName
        lastName
        displayName
      }
      isDeleted
      createdById
      createdAt
      individuals {
        id
        createdBy {
          firstName
          lastName
          displayName
        }
        createdOn
        customFieldValues {
          ...CustomFieldValueFragment
        }
      }
      unknownGroups {
        id
        activityId
        customFieldValues {
          ...CustomFieldValueFragment
        }
        averageAge
        numberOfUsers
        gender
      }
      realities {
        id
        themeId
        specificationId
        values {
          ...CustomFieldValueFragment
        }
      }
      customFieldValues {
        ...CustomFieldValueFragment
      }
      distributions {
        itemId
        distributedAmount
      }
    }
  }
}
    ${CustomFieldValueFragmentFragmentDoc}`;
export const useGetActivityByIdQuery = <
      TData = GetActivityByIdQuery,
      TError = unknown
    >(
      variables: GetActivityByIdQueryVariables,
      options?: UseQueryOptions<GetActivityByIdQuery, TError, TData>
    ) =>
    useQuery<GetActivityByIdQuery, TError, TData>(
      ['getActivityById', variables],
      fetchData<GetActivityByIdQuery, GetActivityByIdQueryVariables>(GetActivityByIdDocument, variables),
      options
    );
export const GetActivityTypesSettingsDocument = `
    query getActivityTypesSettings {
  settings {
    isDistributionEnabled
    isInterventionEnabled
    isMeetingEnabled
    isPresentationEnabled
    isRoutineEnabled
  }
}
    `;
export const useGetActivityTypesSettingsQuery = <
      TData = GetActivityTypesSettingsQuery,
      TError = unknown
    >(
      variables?: GetActivityTypesSettingsQueryVariables,
      options?: UseQueryOptions<GetActivityTypesSettingsQuery, TError, TData>
    ) =>
    useQuery<GetActivityTypesSettingsQuery, TError, TData>(
      variables === undefined ? ['getActivityTypesSettings'] : ['getActivityTypesSettings', variables],
      fetchData<GetActivityTypesSettingsQuery, GetActivityTypesSettingsQueryVariables>(GetActivityTypesSettingsDocument, variables),
      options
    );
export const GetDeletedActivityByIdDocument = `
    query getDeletedActivityById($id: Int!) {
  deletedActivities(where: {id: {eq: $id}}) {
    id
    type
    owningTeamId
    createdBy {
      id
      firstName
      lastName
      displayName
    }
    isDeleted
    createdById
    createdAt
    individuals {
      id
      createdBy {
        firstName
        lastName
        displayName
      }
      createdOn
      customFieldValues {
        ...CustomFieldValueFragment
      }
    }
    unknownGroups {
      id
      activityId
      customFieldValues {
        ...CustomFieldValueFragment
      }
      averageAge
      numberOfUsers
      gender
    }
    realities {
      id
      themeId
      specificationId
      values {
        ...CustomFieldValueFragment
      }
    }
    customFieldValues {
      ...CustomFieldValueFragment
    }
    distributions {
      itemId
      distributedAmount
    }
  }
}
    ${CustomFieldValueFragmentFragmentDoc}`;
export const useGetDeletedActivityByIdQuery = <
      TData = GetDeletedActivityByIdQuery,
      TError = unknown
    >(
      variables: GetDeletedActivityByIdQueryVariables,
      options?: UseQueryOptions<GetDeletedActivityByIdQuery, TError, TData>
    ) =>
    useQuery<GetDeletedActivityByIdQuery, TError, TData>(
      ['getDeletedActivityById', variables],
      fetchData<GetDeletedActivityByIdQuery, GetDeletedActivityByIdQueryVariables>(GetDeletedActivityByIdDocument, variables),
      options
    );
export const GetDistributionItemsByIdsDocument = `
    query getDistributionItemsByIds($itemIds: [Int]!) {
  items(where: {id: {in: $itemIds}}) {
    id
    name
    description
    unit
  }
}
    `;
export const useGetDistributionItemsByIdsQuery = <
      TData = GetDistributionItemsByIdsQuery,
      TError = unknown
    >(
      variables: GetDistributionItemsByIdsQueryVariables,
      options?: UseQueryOptions<GetDistributionItemsByIdsQuery, TError, TData>
    ) =>
    useQuery<GetDistributionItemsByIdsQuery, TError, TData>(
      ['getDistributionItemsByIds', variables],
      fetchData<GetDistributionItemsByIdsQuery, GetDistributionItemsByIdsQueryVariables>(GetDistributionItemsByIdsDocument, variables),
      options
    );
export const GetIndividualsSettingsDocument = `
    query getIndividualsSettings {
  settings {
    isKnownIndividualsEnabled
  }
}
    `;
export const useGetIndividualsSettingsQuery = <
      TData = GetIndividualsSettingsQuery,
      TError = unknown
    >(
      variables?: GetIndividualsSettingsQueryVariables,
      options?: UseQueryOptions<GetIndividualsSettingsQuery, TError, TData>
    ) =>
    useQuery<GetIndividualsSettingsQuery, TError, TData>(
      variables === undefined ? ['getIndividualsSettings'] : ['getIndividualsSettings', variables],
      fetchData<GetIndividualsSettingsQuery, GetIndividualsSettingsQueryVariables>(GetIndividualsSettingsDocument, variables),
      options
    );
export const GetOptionsBySystemFieldIdDocument = `
    query getOptionsBySystemFieldId($systemFieldId: SystemFieldId) {
  options(where: {customField: {systemFieldId: {eq: $systemFieldId}}}) {
    id
    name
    order
    customFieldId
  }
}
    `;
export const useGetOptionsBySystemFieldIdQuery = <
      TData = GetOptionsBySystemFieldIdQuery,
      TError = unknown
    >(
      variables?: GetOptionsBySystemFieldIdQueryVariables,
      options?: UseQueryOptions<GetOptionsBySystemFieldIdQuery, TError, TData>
    ) =>
    useQuery<GetOptionsBySystemFieldIdQuery, TError, TData>(
      variables === undefined ? ['getOptionsBySystemFieldId'] : ['getOptionsBySystemFieldId', variables],
      fetchData<GetOptionsBySystemFieldIdQuery, GetOptionsBySystemFieldIdQueryVariables>(GetOptionsBySystemFieldIdDocument, variables),
      options
    );
export const RealitiesDataDocument = `
    query realitiesData {
  themes {
    id
    name
    description
    specifications {
      id
      name
    }
  }
  accompaniments: options(
    where: {customField: {systemFieldId: {eq: RealityAccompaniments}}}
  ) {
    id
    name
    isSystemOption
  }
  referrals: options(
    where: {customField: {systemFieldId: {eq: RealityReferrals}}}
  ) {
    id
    name
    isSystemOption
  }
  approaches: options(
    where: {customField: {systemFieldId: {eq: RealityApproaches}}}
  ) {
    id
    name
    isSystemOption
  }
}
    `;
export const useRealitiesDataQuery = <
      TData = RealitiesDataQuery,
      TError = unknown
    >(
      variables?: RealitiesDataQueryVariables,
      options?: UseQueryOptions<RealitiesDataQuery, TError, TData>
    ) =>
    useQuery<RealitiesDataQuery, TError, TData>(
      variables === undefined ? ['realitiesData'] : ['realitiesData', variables],
      fetchData<RealitiesDataQuery, RealitiesDataQueryVariables>(RealitiesDataDocument, variables),
      options
    );
export const GetCurrentUserDocument = `
    query getCurrentUser {
  me {
    id
    displayName
    status
    teams {
      id
      name
    }
    roles {
      name
      normalizedName
    }
  }
}
    `;
export const useGetCurrentUserQuery = <
      TData = GetCurrentUserQuery,
      TError = unknown
    >(
      variables?: GetCurrentUserQueryVariables,
      options?: UseQueryOptions<GetCurrentUserQuery, TError, TData>
    ) =>
    useQuery<GetCurrentUserQuery, TError, TData>(
      variables === undefined ? ['getCurrentUser'] : ['getCurrentUser', variables],
      fetchData<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, variables),
      options
    );
export const AddCustomPropertyDocument = `
    mutation addCustomProperty($input: AddCustomPropertyInput!) {
  addCustomProperty(input: $input) {
    customField {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useAddCustomPropertyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddCustomPropertyMutation, TError, AddCustomPropertyMutationVariables, TContext>) =>
    useMutation<AddCustomPropertyMutation, TError, AddCustomPropertyMutationVariables, TContext>(
      ['addCustomProperty'],
      (variables?: AddCustomPropertyMutationVariables) => fetchData<AddCustomPropertyMutation, AddCustomPropertyMutationVariables>(AddCustomPropertyDocument, variables)(),
      options
    );
export const AddExistingCustomFieldDocument = `
    mutation addExistingCustomField($input: AddFieldToEntityTypeInput!) {
  addFieldToEntityType(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useAddExistingCustomFieldMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddExistingCustomFieldMutation, TError, AddExistingCustomFieldMutationVariables, TContext>) =>
    useMutation<AddExistingCustomFieldMutation, TError, AddExistingCustomFieldMutationVariables, TContext>(
      ['addExistingCustomField'],
      (variables?: AddExistingCustomFieldMutationVariables) => fetchData<AddExistingCustomFieldMutation, AddExistingCustomFieldMutationVariables>(AddExistingCustomFieldDocument, variables)(),
      options
    );
export const AddSectionDocument = `
    mutation addSection($input: AddSectionInput!) {
  addSection(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useAddSectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddSectionMutation, TError, AddSectionMutationVariables, TContext>) =>
    useMutation<AddSectionMutation, TError, AddSectionMutationVariables, TContext>(
      ['addSection'],
      (variables?: AddSectionMutationVariables) => fetchData<AddSectionMutation, AddSectionMutationVariables>(AddSectionDocument, variables)(),
      options
    );
export const DeleteCustomFieldDocument = `
    mutation deleteCustomField($input: DeleteCustomFieldInput!) {
  deleteCustomField(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useDeleteCustomFieldMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCustomFieldMutation, TError, DeleteCustomFieldMutationVariables, TContext>) =>
    useMutation<DeleteCustomFieldMutation, TError, DeleteCustomFieldMutationVariables, TContext>(
      ['deleteCustomField'],
      (variables?: DeleteCustomFieldMutationVariables) => fetchData<DeleteCustomFieldMutation, DeleteCustomFieldMutationVariables>(DeleteCustomFieldDocument, variables)(),
      options
    );
export const DeleteSectionDocument = `
    mutation deleteSection($id: Int!) {
  deleteSection(input: {id: $id}) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useDeleteSectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteSectionMutation, TError, DeleteSectionMutationVariables, TContext>) =>
    useMutation<DeleteSectionMutation, TError, DeleteSectionMutationVariables, TContext>(
      ['deleteSection'],
      (variables?: DeleteSectionMutationVariables) => fetchData<DeleteSectionMutation, DeleteSectionMutationVariables>(DeleteSectionDocument, variables)(),
      options
    );
export const EditSectionDocument = `
    mutation editSection($input: EditSectionInput!) {
  editSection(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useEditSectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditSectionMutation, TError, EditSectionMutationVariables, TContext>) =>
    useMutation<EditSectionMutation, TError, EditSectionMutationVariables, TContext>(
      ['editSection'],
      (variables?: EditSectionMutationVariables) => fetchData<EditSectionMutation, EditSectionMutationVariables>(EditSectionDocument, variables)(),
      options
    );
export const ReorderFieldsDocument = `
    mutation reorderFields($input: ReorderFieldsInput!) {
  reorderFields(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useReorderFieldsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReorderFieldsMutation, TError, ReorderFieldsMutationVariables, TContext>) =>
    useMutation<ReorderFieldsMutation, TError, ReorderFieldsMutationVariables, TContext>(
      ['reorderFields'],
      (variables?: ReorderFieldsMutationVariables) => fetchData<ReorderFieldsMutation, ReorderFieldsMutationVariables>(ReorderFieldsDocument, variables)(),
      options
    );
export const UpdateCustomPropertyDocument = `
    mutation updateCustomProperty($input: EditCustomPropertyInput!) {
  editCustomProperty(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useUpdateCustomPropertyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCustomPropertyMutation, TError, UpdateCustomPropertyMutationVariables, TContext>) =>
    useMutation<UpdateCustomPropertyMutation, TError, UpdateCustomPropertyMutationVariables, TContext>(
      ['updateCustomProperty'],
      (variables?: UpdateCustomPropertyMutationVariables) => fetchData<UpdateCustomPropertyMutation, UpdateCustomPropertyMutationVariables>(UpdateCustomPropertyDocument, variables)(),
      options
    );
export const FindCustomFieldsDocument = `
    query findCustomFields($filter: CustomFieldDtoFilterInput) {
  customFields(where: $filter) {
    id
    customFieldType
    isSystemField
    name
    description
    status
    isRequired
    allowMultipleValues
    numberOfLines
    systemFieldId
    entityTypes {
      id
      order
      entityType
      sectionId
    }
    options {
      id
      name
      order
      customFieldId
    }
  }
}
    `;
export const useFindCustomFieldsQuery = <
      TData = FindCustomFieldsQuery,
      TError = unknown
    >(
      variables?: FindCustomFieldsQueryVariables,
      options?: UseQueryOptions<FindCustomFieldsQuery, TError, TData>
    ) =>
    useQuery<FindCustomFieldsQuery, TError, TData>(
      variables === undefined ? ['findCustomFields'] : ['findCustomFields', variables],
      fetchData<FindCustomFieldsQuery, FindCustomFieldsQueryVariables>(FindCustomFieldsDocument, variables),
      options
    );
export const FindSectionsDocument = `
    query findSections($filter: FieldSectionDtoFilterInput) {
  sections(where: $filter) {
    id
    name
    order
    fieldEntityTypes(order: {order: ASC}) {
      id
      order
      sectionId
      entityType
      customFieldId
      customFieldDto {
        id
        customFieldType
        isSystemField
        systemFieldId
        allowMultipleValues
        numberOfLines
        name
        description
        status
        options {
          id
          name
          order
          customFieldId
          isSystemOption
        }
        isRequired
      }
    }
  }
}
    `;
export const useFindSectionsQuery = <
      TData = FindSectionsQuery,
      TError = unknown
    >(
      variables?: FindSectionsQueryVariables,
      options?: UseQueryOptions<FindSectionsQuery, TError, TData>
    ) =>
    useQuery<FindSectionsQuery, TError, TData>(
      variables === undefined ? ['findSections'] : ['findSections', variables],
      fetchData<FindSectionsQuery, FindSectionsQueryVariables>(FindSectionsDocument, variables),
      options
    );
export const GetOptionsByCustomFieldIdDocument = `
    query getOptionsByCustomFieldId($customFieldId: Int) {
  options(where: {customFieldId: {eq: $customFieldId}}) {
    id
    name
    order
    customFieldId
    isSystemOption
  }
}
    `;
export const useGetOptionsByCustomFieldIdQuery = <
      TData = GetOptionsByCustomFieldIdQuery,
      TError = unknown
    >(
      variables?: GetOptionsByCustomFieldIdQueryVariables,
      options?: UseQueryOptions<GetOptionsByCustomFieldIdQuery, TError, TData>
    ) =>
    useQuery<GetOptionsByCustomFieldIdQuery, TError, TData>(
      variables === undefined ? ['getOptionsByCustomFieldId'] : ['getOptionsByCustomFieldId', variables],
      fetchData<GetOptionsByCustomFieldIdQuery, GetOptionsByCustomFieldIdQueryVariables>(GetOptionsByCustomFieldIdDocument, variables),
      options
    );
export const CustomFieldAddedDocument = `
    subscription customFieldAdded {
  customFieldAdded {
    id
  }
}
    `;
export const CustomFieldUpdatedDocument = `
    subscription customFieldUpdated {
  customFieldUpdated {
    id
  }
}
    `;
export const AddDistrubtionCategoryDocument = `
    mutation addDistrubtionCategory($input: AddDistributionCategoryInput!) {
  addDistributionCategory(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useAddDistrubtionCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddDistrubtionCategoryMutation, TError, AddDistrubtionCategoryMutationVariables, TContext>) =>
    useMutation<AddDistrubtionCategoryMutation, TError, AddDistrubtionCategoryMutationVariables, TContext>(
      ['addDistrubtionCategory'],
      (variables?: AddDistrubtionCategoryMutationVariables) => fetchData<AddDistrubtionCategoryMutation, AddDistrubtionCategoryMutationVariables>(AddDistrubtionCategoryDocument, variables)(),
      options
    );
export const EditDistrubtionCategoryDocument = `
    mutation editDistrubtionCategory($input: EditDistributionCategoryInput!) {
  editDistributionCategory(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useEditDistrubtionCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditDistrubtionCategoryMutation, TError, EditDistrubtionCategoryMutationVariables, TContext>) =>
    useMutation<EditDistrubtionCategoryMutation, TError, EditDistrubtionCategoryMutationVariables, TContext>(
      ['editDistrubtionCategory'],
      (variables?: EditDistrubtionCategoryMutationVariables) => fetchData<EditDistrubtionCategoryMutation, EditDistrubtionCategoryMutationVariables>(EditDistrubtionCategoryDocument, variables)(),
      options
    );
export const DeleteDistributionCategoryDocument = `
    mutation deleteDistributionCategory($input: DeleteDistributionCategoryInput!) {
  deleteDistributionCategory(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useDeleteDistributionCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteDistributionCategoryMutation, TError, DeleteDistributionCategoryMutationVariables, TContext>) =>
    useMutation<DeleteDistributionCategoryMutation, TError, DeleteDistributionCategoryMutationVariables, TContext>(
      ['deleteDistributionCategory'],
      (variables?: DeleteDistributionCategoryMutationVariables) => fetchData<DeleteDistributionCategoryMutation, DeleteDistributionCategoryMutationVariables>(DeleteDistributionCategoryDocument, variables)(),
      options
    );
export const AddDistrubtionItemDocument = `
    mutation addDistrubtionItem($input: AddDistributionItemInput!) {
  addDistributionItem(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useAddDistrubtionItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddDistrubtionItemMutation, TError, AddDistrubtionItemMutationVariables, TContext>) =>
    useMutation<AddDistrubtionItemMutation, TError, AddDistrubtionItemMutationVariables, TContext>(
      ['addDistrubtionItem'],
      (variables?: AddDistrubtionItemMutationVariables) => fetchData<AddDistrubtionItemMutation, AddDistrubtionItemMutationVariables>(AddDistrubtionItemDocument, variables)(),
      options
    );
export const EditDistrubtionItemDocument = `
    mutation editDistrubtionItem($input: EditDistributionItemInput!) {
  editDistributionItem(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useEditDistrubtionItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditDistrubtionItemMutation, TError, EditDistrubtionItemMutationVariables, TContext>) =>
    useMutation<EditDistrubtionItemMutation, TError, EditDistrubtionItemMutationVariables, TContext>(
      ['editDistrubtionItem'],
      (variables?: EditDistrubtionItemMutationVariables) => fetchData<EditDistrubtionItemMutation, EditDistrubtionItemMutationVariables>(EditDistrubtionItemDocument, variables)(),
      options
    );
export const DeleteDistributionItemDocument = `
    mutation deleteDistributionItem($input: DeleteDistributionItemInput!) {
  deleteDistributionItem(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useDeleteDistributionItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteDistributionItemMutation, TError, DeleteDistributionItemMutationVariables, TContext>) =>
    useMutation<DeleteDistributionItemMutation, TError, DeleteDistributionItemMutationVariables, TContext>(
      ['deleteDistributionItem'],
      (variables?: DeleteDistributionItemMutationVariables) => fetchData<DeleteDistributionItemMutation, DeleteDistributionItemMutationVariables>(DeleteDistributionItemDocument, variables)(),
      options
    );
export const ReorderDistributionCategoriesDocument = `
    mutation reorderDistributionCategories($input: ReorderDistributionCategoriesInput!) {
  reorderDistributionCategories(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useReorderDistributionCategoriesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReorderDistributionCategoriesMutation, TError, ReorderDistributionCategoriesMutationVariables, TContext>) =>
    useMutation<ReorderDistributionCategoriesMutation, TError, ReorderDistributionCategoriesMutationVariables, TContext>(
      ['reorderDistributionCategories'],
      (variables?: ReorderDistributionCategoriesMutationVariables) => fetchData<ReorderDistributionCategoriesMutation, ReorderDistributionCategoriesMutationVariables>(ReorderDistributionCategoriesDocument, variables)(),
      options
    );
export const FindDistributionCategoriesDocument = `
    query findDistributionCategories($input: DistributionCategoryDtoFilterInput) {
  categories(where: $input) {
    id
    name
  }
}
    `;
export const useFindDistributionCategoriesQuery = <
      TData = FindDistributionCategoriesQuery,
      TError = unknown
    >(
      variables?: FindDistributionCategoriesQueryVariables,
      options?: UseQueryOptions<FindDistributionCategoriesQuery, TError, TData>
    ) =>
    useQuery<FindDistributionCategoriesQuery, TError, TData>(
      variables === undefined ? ['findDistributionCategories'] : ['findDistributionCategories', variables],
      fetchData<FindDistributionCategoriesQuery, FindDistributionCategoriesQueryVariables>(FindDistributionCategoriesDocument, variables),
      options
    );
export const FindDistributionItemsDocument = `
    query findDistributionItems($filter: DistributionItemDtoFilterInput) {
  items(where: $filter) {
    id
    name
    description
    unit
    isDisabled
    categoryIds
  }
}
    `;
export const useFindDistributionItemsQuery = <
      TData = FindDistributionItemsQuery,
      TError = unknown
    >(
      variables?: FindDistributionItemsQueryVariables,
      options?: UseQueryOptions<FindDistributionItemsQuery, TError, TData>
    ) =>
    useQuery<FindDistributionItemsQuery, TError, TData>(
      variables === undefined ? ['findDistributionItems'] : ['findDistributionItems', variables],
      fetchData<FindDistributionItemsQuery, FindDistributionItemsQueryVariables>(FindDistributionItemsDocument, variables),
      options
    );
export const GetActivitiesByTypeInDateRangeDocument = `
    query getActivitiesByTypeInDateRange($min: DateTime!, $max: DateTime!, $createdBy: String!, $teamsId: [Int]!) {
  activitiesCountByType(
    where: {and: [{or: [{createdBy: {id: {eq: $createdBy}}}, {owningTeamId: {in: $teamsId}}]}, {interventionDate: {lte: $max}}, {interventionDate: {gte: $min}}]}
  ) {
    activityType
    count
  }
}
    `;
export const useGetActivitiesByTypeInDateRangeQuery = <
      TData = GetActivitiesByTypeInDateRangeQuery,
      TError = unknown
    >(
      variables: GetActivitiesByTypeInDateRangeQueryVariables,
      options?: UseQueryOptions<GetActivitiesByTypeInDateRangeQuery, TError, TData>
    ) =>
    useQuery<GetActivitiesByTypeInDateRangeQuery, TError, TData>(
      ['getActivitiesByTypeInDateRange', variables],
      fetchData<GetActivitiesByTypeInDateRangeQuery, GetActivitiesByTypeInDateRangeQueryVariables>(GetActivitiesByTypeInDateRangeDocument, variables),
      options
    );
export const GetActivitiesCountByDateInDateRangeDocument = `
    query getActivitiesCountByDateInDateRange($min: DateTime!, $max: DateTime!, $createdBy: String!, $teamsId: [Int]!) {
  activitiesCountByDate(
    where: {and: [{or: [{createdBy: {id: {eq: $createdBy}}}, {owningTeamId: {in: $teamsId}}]}, {interventionDate: {lte: $max}}, {interventionDate: {gte: $min}}]}
  ) {
    activityType
    date
    count
  }
}
    `;
export const useGetActivitiesCountByDateInDateRangeQuery = <
      TData = GetActivitiesCountByDateInDateRangeQuery,
      TError = unknown
    >(
      variables: GetActivitiesCountByDateInDateRangeQueryVariables,
      options?: UseQueryOptions<GetActivitiesCountByDateInDateRangeQuery, TError, TData>
    ) =>
    useQuery<GetActivitiesCountByDateInDateRangeQuery, TError, TData>(
      ['getActivitiesCountByDateInDateRange', variables],
      fetchData<GetActivitiesCountByDateInDateRangeQuery, GetActivitiesCountByDateInDateRangeQueryVariables>(GetActivitiesCountByDateInDateRangeDocument, variables),
      options
    );
export const GetIndividualsCountByGenderDocument = `
    query getIndividualsCountByGender($min: DateTime!, $max: DateTime!, $createdBy: String!, $teamsId: [Int]!) {
  individualsCountByGender(
    where: {and: [{or: [{createdBy: {id: {eq: $createdBy}}}, {owningTeamId: {in: $teamsId}}]}, {interventionDate: {lte: $max}}, {interventionDate: {gte: $min}}]}
  ) {
    gender
    count
  }
}
    `;
export const useGetIndividualsCountByGenderQuery = <
      TData = GetIndividualsCountByGenderQuery,
      TError = unknown
    >(
      variables: GetIndividualsCountByGenderQueryVariables,
      options?: UseQueryOptions<GetIndividualsCountByGenderQuery, TError, TData>
    ) =>
    useQuery<GetIndividualsCountByGenderQuery, TError, TData>(
      ['getIndividualsCountByGender', variables],
      fetchData<GetIndividualsCountByGenderQuery, GetIndividualsCountByGenderQueryVariables>(GetIndividualsCountByGenderDocument, variables),
      options
    );
export const GetLatestActivitiesDocument = `
    query getLatestActivities($min: DateTime!, $max: DateTime!, $createdBy: String!, $teamsId: [Int]!) {
  latestActivities(
    where: {and: [{or: [{createdBy: {id: {eq: $createdBy}}}, {owningTeamId: {in: $teamsId}}]}, {interventionDate: {lte: $max}}, {interventionDate: {gte: $min}}]}
  ) {
    id
    type
    createdAt
    customFieldValues {
      ...CustomFieldValueFragment
    }
  }
}
    ${CustomFieldValueFragmentFragmentDoc}`;
export const useGetLatestActivitiesQuery = <
      TData = GetLatestActivitiesQuery,
      TError = unknown
    >(
      variables: GetLatestActivitiesQueryVariables,
      options?: UseQueryOptions<GetLatestActivitiesQuery, TError, TData>
    ) =>
    useQuery<GetLatestActivitiesQuery, TError, TData>(
      ['getLatestActivities', variables],
      fetchData<GetLatestActivitiesQuery, GetLatestActivitiesQueryVariables>(GetLatestActivitiesDocument, variables),
      options
    );
export const GetLatestIndividualsDocument = `
    query getLatestIndividuals($min: DateTime!, $max: DateTime!, $createdBy: String!, $teamsId: [Int]!) {
  latestIndividuals(
    where: {and: [{or: [{createdBy: {id: {eq: $createdBy}}}, {owningTeamId: {in: $teamsId}}]}, {interventionDate: {lte: $max}}, {interventionDate: {gte: $min}}]}
  ) {
    id
    activityDate
    nickname
    birthday
    genderId
  }
}
    `;
export const useGetLatestIndividualsQuery = <
      TData = GetLatestIndividualsQuery,
      TError = unknown
    >(
      variables: GetLatestIndividualsQueryVariables,
      options?: UseQueryOptions<GetLatestIndividualsQuery, TError, TData>
    ) =>
    useQuery<GetLatestIndividualsQuery, TError, TData>(
      ['getLatestIndividuals', variables],
      fetchData<GetLatestIndividualsQuery, GetLatestIndividualsQueryVariables>(GetLatestIndividualsDocument, variables),
      options
    );
export const GetOptionsbySystemFieldIdDocument = `
    query getOptionsbySystemFieldId($systemFieldId: SystemFieldId) {
  options(where: {customField: {systemFieldId: {eq: $systemFieldId}}}) {
    id
    name
  }
}
    `;
export const useGetOptionsbySystemFieldIdQuery = <
      TData = GetOptionsbySystemFieldIdQuery,
      TError = unknown
    >(
      variables?: GetOptionsbySystemFieldIdQueryVariables,
      options?: UseQueryOptions<GetOptionsbySystemFieldIdQuery, TError, TData>
    ) =>
    useQuery<GetOptionsbySystemFieldIdQuery, TError, TData>(
      variables === undefined ? ['getOptionsbySystemFieldId'] : ['getOptionsbySystemFieldId', variables],
      fetchData<GetOptionsbySystemFieldIdQuery, GetOptionsbySystemFieldIdQueryVariables>(GetOptionsbySystemFieldIdDocument, variables),
      options
    );
export const GetTeamsActivitiesCountDocument = `
    query getTeamsActivitiesCount($min: DateTime!, $max: DateTime!, $createdBy: String!, $teamsId: [Int]!) {
  activitiesCountByTeam(
    where: {and: [{or: [{createdBy: {id: {eq: $createdBy}}}, {owningTeamId: {in: $teamsId}}]}, {interventionDate: {lte: $max}}, {interventionDate: {gte: $min}}]}
  ) {
    id
    name
    teamId
    teamName
    lastActivityDate
    distributions
    interventions
    meetings
    presentations
    routines
  }
}
    `;
export const useGetTeamsActivitiesCountQuery = <
      TData = GetTeamsActivitiesCountQuery,
      TError = unknown
    >(
      variables: GetTeamsActivitiesCountQueryVariables,
      options?: UseQueryOptions<GetTeamsActivitiesCountQuery, TError, TData>
    ) =>
    useQuery<GetTeamsActivitiesCountQuery, TError, TData>(
      ['getTeamsActivitiesCount', variables],
      fetchData<GetTeamsActivitiesCountQuery, GetTeamsActivitiesCountQueryVariables>(GetTeamsActivitiesCountDocument, variables),
      options
    );
export const GetTopDistributedItemsDocument = `
    query getTopDistributedItems($min: DateTime!, $max: DateTime!, $createdBy: String!, $teamsId: [Int]!) {
  topDistributedItems(
    where: {and: [{or: [{createdBy: {id: {eq: $createdBy}}}, {owningTeamId: {in: $teamsId}}]}, {interventionDate: {lte: $max}}, {interventionDate: {gte: $min}}]}
  ) {
    id
    quantity
    name
  }
}
    `;
export const useGetTopDistributedItemsQuery = <
      TData = GetTopDistributedItemsQuery,
      TError = unknown
    >(
      variables: GetTopDistributedItemsQueryVariables,
      options?: UseQueryOptions<GetTopDistributedItemsQuery, TError, TData>
    ) =>
    useQuery<GetTopDistributedItemsQuery, TError, TData>(
      ['getTopDistributedItems', variables],
      fetchData<GetTopDistributedItemsQuery, GetTopDistributedItemsQueryVariables>(GetTopDistributedItemsDocument, variables),
      options
    );
export const AddIndividualDocument = `
    mutation addIndividual($input: AddIndividualInput!) {
  addIndividual(input: $input) {
    individual {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useAddIndividualMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddIndividualMutation, TError, AddIndividualMutationVariables, TContext>) =>
    useMutation<AddIndividualMutation, TError, AddIndividualMutationVariables, TContext>(
      ['addIndividual'],
      (variables?: AddIndividualMutationVariables) => fetchData<AddIndividualMutation, AddIndividualMutationVariables>(AddIndividualDocument, variables)(),
      options
    );
export const DeleteIndividualDocument = `
    mutation deleteIndividual($input: DeleteIndividualInput!) {
  deleteIndividual(input: $input) {
    individual {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useDeleteIndividualMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteIndividualMutation, TError, DeleteIndividualMutationVariables, TContext>) =>
    useMutation<DeleteIndividualMutation, TError, DeleteIndividualMutationVariables, TContext>(
      ['deleteIndividual'],
      (variables?: DeleteIndividualMutationVariables) => fetchData<DeleteIndividualMutation, DeleteIndividualMutationVariables>(DeleteIndividualDocument, variables)(),
      options
    );
export const EditIndividualDocument = `
    mutation editIndividual($input: EditIndividualInput!) {
  editIndividual(input: $input) {
    individual {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useEditIndividualMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditIndividualMutation, TError, EditIndividualMutationVariables, TContext>) =>
    useMutation<EditIndividualMutation, TError, EditIndividualMutationVariables, TContext>(
      ['editIndividual'],
      (variables?: EditIndividualMutationVariables) => fetchData<EditIndividualMutation, EditIndividualMutationVariables>(EditIndividualDocument, variables)(),
      options
    );
export const MergeIndividualsDocument = `
    mutation mergeIndividuals($input: MergeIndividualsInput!) {
  mergeIndividuals(input: $input) {
    individual {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useMergeIndividualsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MergeIndividualsMutation, TError, MergeIndividualsMutationVariables, TContext>) =>
    useMutation<MergeIndividualsMutation, TError, MergeIndividualsMutationVariables, TContext>(
      ['mergeIndividuals'],
      (variables?: MergeIndividualsMutationVariables) => fetchData<MergeIndividualsMutation, MergeIndividualsMutationVariables>(MergeIndividualsDocument, variables)(),
      options
    );
export const RestoreIndividualDocument = `
    mutation restoreIndividual($input: RestoreIndividualInput!) {
  restoreIndividual(input: $input) {
    individual {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useRestoreIndividualMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RestoreIndividualMutation, TError, RestoreIndividualMutationVariables, TContext>) =>
    useMutation<RestoreIndividualMutation, TError, RestoreIndividualMutationVariables, TContext>(
      ['restoreIndividual'],
      (variables?: RestoreIndividualMutationVariables) => fetchData<RestoreIndividualMutation, RestoreIndividualMutationVariables>(RestoreIndividualDocument, variables)(),
      options
    );
export const FindDeletedIndividualsDocument = `
    query findDeletedIndividuals($filter: IndividualFilterInput) {
  deletedIndividuals(where: $filter) {
    id
    createdOn
    nickName
    birthday
    gender
    isDeleted
    customFieldValues {
      ...CustomFieldValueFragment
    }
  }
}
    ${CustomFieldValueFragmentFragmentDoc}`;
export const useFindDeletedIndividualsQuery = <
      TData = FindDeletedIndividualsQuery,
      TError = unknown
    >(
      variables?: FindDeletedIndividualsQueryVariables,
      options?: UseQueryOptions<FindDeletedIndividualsQuery, TError, TData>
    ) =>
    useQuery<FindDeletedIndividualsQuery, TError, TData>(
      variables === undefined ? ['findDeletedIndividuals'] : ['findDeletedIndividuals', variables],
      fetchData<FindDeletedIndividualsQuery, FindDeletedIndividualsQueryVariables>(FindDeletedIndividualsDocument, variables),
      options
    );
export const FindIndividualsDocument = `
    query findIndividuals($input: IndividualFilterInput, $searchTerm: String!, $pageSize: Int!, $skip: Int!, $showDeleted: Boolean = false) {
  searchIndividuals(
    take: $pageSize
    skip: $skip
    where: $input
    searchTerm: $searchTerm
    showDeleted: $showDeleted
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      customFieldValues {
        ...CustomFieldValueFragment
      }
      nickName
      birthday
      gender
    }
  }
}
    ${CustomFieldValueFragmentFragmentDoc}`;
export const useFindIndividualsQuery = <
      TData = FindIndividualsQuery,
      TError = unknown
    >(
      variables: FindIndividualsQueryVariables,
      options?: UseQueryOptions<FindIndividualsQuery, TError, TData>
    ) =>
    useQuery<FindIndividualsQuery, TError, TData>(
      ['findIndividuals', variables],
      fetchData<FindIndividualsQuery, FindIndividualsQueryVariables>(FindIndividualsDocument, variables),
      options
    );
export const AddTenantDocument = `
    mutation addTenant($input: AddTenantInput!) {
  addTenant(input: $input) {
    tenant {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useAddTenantMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddTenantMutation, TError, AddTenantMutationVariables, TContext>) =>
    useMutation<AddTenantMutation, TError, AddTenantMutationVariables, TContext>(
      ['addTenant'],
      (variables?: AddTenantMutationVariables) => fetchData<AddTenantMutation, AddTenantMutationVariables>(AddTenantDocument, variables)(),
      options
    );
export const EditTenantDocument = `
    mutation editTenant($input: EditTenantInput!) {
  editTenant(input: $input) {
    tenant {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useEditTenantMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditTenantMutation, TError, EditTenantMutationVariables, TContext>) =>
    useMutation<EditTenantMutation, TError, EditTenantMutationVariables, TContext>(
      ['editTenant'],
      (variables?: EditTenantMutationVariables) => fetchData<EditTenantMutation, EditTenantMutationVariables>(EditTenantDocument, variables)(),
      options
    );
export const FindTenantsDocument = `
    query findTenants($filter: TenantFilterInput) {
  tenants(where: $filter) {
    id
    name
    region
    town
    isProvisioned
    isIncludedInGlobalReport
  }
}
    `;
export const useFindTenantsQuery = <
      TData = FindTenantsQuery,
      TError = unknown
    >(
      variables?: FindTenantsQueryVariables,
      options?: UseQueryOptions<FindTenantsQuery, TError, TData>
    ) =>
    useQuery<FindTenantsQuery, TError, TData>(
      variables === undefined ? ['findTenants'] : ['findTenants', variables],
      fetchData<FindTenantsQuery, FindTenantsQueryVariables>(FindTenantsDocument, variables),
      options
    );
export const GetTenantByIdDocument = `
    query getTenantById($tenantId: String!) {
  tenants(where: {id: {eq: $tenantId}}) {
    id
    name
    identifier
    region
    town
    telephone
    extensionTelephone
    email
    isIncludedInGlobalReport
  }
}
    `;
export const useGetTenantByIdQuery = <
      TData = GetTenantByIdQuery,
      TError = unknown
    >(
      variables: GetTenantByIdQueryVariables,
      options?: UseQueryOptions<GetTenantByIdQuery, TError, TData>
    ) =>
    useQuery<GetTenantByIdQuery, TError, TData>(
      ['getTenantById', variables],
      fetchData<GetTenantByIdQuery, GetTenantByIdQueryVariables>(GetTenantByIdDocument, variables),
      options
    );
export const EditSpecificationsDocument = `
    mutation editSpecifications($input: EditSpecificationsInput!) {
  editSpecifications(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useEditSpecificationsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditSpecificationsMutation, TError, EditSpecificationsMutationVariables, TContext>) =>
    useMutation<EditSpecificationsMutation, TError, EditSpecificationsMutationVariables, TContext>(
      ['editSpecifications'],
      (variables?: EditSpecificationsMutationVariables) => fetchData<EditSpecificationsMutation, EditSpecificationsMutationVariables>(EditSpecificationsDocument, variables)(),
      options
    );
export const FindThemesWithSpecificationsDocument = `
    query findThemesWithSpecifications($filter: RealityThemeDtoFilterInput) {
  themes(where: $filter) {
    id
    name
    specifications {
      id
      name
    }
  }
}
    `;
export const useFindThemesWithSpecificationsQuery = <
      TData = FindThemesWithSpecificationsQuery,
      TError = unknown
    >(
      variables?: FindThemesWithSpecificationsQueryVariables,
      options?: UseQueryOptions<FindThemesWithSpecificationsQuery, TError, TData>
    ) =>
    useQuery<FindThemesWithSpecificationsQuery, TError, TData>(
      variables === undefined ? ['findThemesWithSpecifications'] : ['findThemesWithSpecifications', variables],
      fetchData<FindThemesWithSpecificationsQuery, FindThemesWithSpecificationsQueryVariables>(FindThemesWithSpecificationsDocument, variables),
      options
    );
export const AddReportModelDocument = `
    mutation addReportModel($input: AddReportModelInput!) {
  addReportModel(input: $input) {
    report {
      id
      name
      reportValues {
        ageGroupBoundaries
        genderBreakdown
        includeUnknownIndividuals
        fieldsVisibility {
          visibleCustomFieldIds
          areThemesVisible
          areSpecificationsVisible
          areActivityTypesVisible
          areDistributionsVisible
        }
        filters {
          period {
            from
            to
          }
          activityTypes
          themeIds
          specificationIds
          itemIds
          categoryIds
          distributedAmounts {
            min
            max
          }
          customFieldFilters {
            ...ReportFieldFilterFragment
          }
          individualsFieldFilters {
            ...ReportFieldFilterFragment
          }
          unknownGroupFieldFilters {
            ...ReportFieldFilterFragment
          }
          realitiesFieldFilters {
            ...ReportFieldFilterFragment
          }
          useOutreachWorkersOrLogic
        }
      }
      lastUpdated
    }
  }
}
    ${ReportFieldFilterFragmentFragmentDoc}`;
export const useAddReportModelMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddReportModelMutation, TError, AddReportModelMutationVariables, TContext>) =>
    useMutation<AddReportModelMutation, TError, AddReportModelMutationVariables, TContext>(
      ['addReportModel'],
      (variables?: AddReportModelMutationVariables) => fetchData<AddReportModelMutation, AddReportModelMutationVariables>(AddReportModelDocument, variables)(),
      options
    );
export const DeleteModelDocument = `
    mutation deleteModel($input: DeleteReportModelInput!) {
  deleteReportModel(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useDeleteModelMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteModelMutation, TError, DeleteModelMutationVariables, TContext>) =>
    useMutation<DeleteModelMutation, TError, DeleteModelMutationVariables, TContext>(
      ['deleteModel'],
      (variables?: DeleteModelMutationVariables) => fetchData<DeleteModelMutation, DeleteModelMutationVariables>(DeleteModelDocument, variables)(),
      options
    );
export const EditReportModelDocument = `
    mutation editReportModel($input: EditReportModelInput!) {
  editReportModel(input: $input) {
    report {
      id
    }
  }
}
    `;
export const useEditReportModelMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditReportModelMutation, TError, EditReportModelMutationVariables, TContext>) =>
    useMutation<EditReportModelMutation, TError, EditReportModelMutationVariables, TContext>(
      ['editReportModel'],
      (variables?: EditReportModelMutationVariables) => fetchData<EditReportModelMutation, EditReportModelMutationVariables>(EditReportModelDocument, variables)(),
      options
    );
export const GetModelsDocument = `
    query getModels {
  models {
    id
    name
    lastUpdated
    reportValues {
      ageGroupBoundaries
      genderBreakdown
      includeUnknownIndividuals
      fieldsVisibility {
        visibleCustomFieldIds
        areThemesVisible
        areSpecificationsVisible
        areActivityTypesVisible
        areDistributionsVisible
      }
      filters {
        period {
          from
          to
        }
        activityTypes
        themeIds
        specificationIds
        itemIds
        categoryIds
        distributedAmounts {
          min
          max
        }
        customFieldFilters {
          ...ReportFieldFilterFragment
        }
        individualsFieldFilters {
          ...ReportFieldFilterFragment
        }
        unknownGroupFieldFilters {
          ...ReportFieldFilterFragment
        }
        realitiesFieldFilters {
          ...ReportFieldFilterFragment
        }
        useOutreachWorkersOrLogic
      }
    }
  }
}
    ${ReportFieldFilterFragmentFragmentDoc}`;
export const useGetModelsQuery = <
      TData = GetModelsQuery,
      TError = unknown
    >(
      variables?: GetModelsQueryVariables,
      options?: UseQueryOptions<GetModelsQuery, TError, TData>
    ) =>
    useQuery<GetModelsQuery, TError, TData>(
      variables === undefined ? ['getModels'] : ['getModels', variables],
      fetchData<GetModelsQuery, GetModelsQueryVariables>(GetModelsDocument, variables),
      options
    );
export const GetReportCountDocument = `
    query getReportCount($input: ReportParametersInput!) {
  reportCount(input: $input) {
    activitiesCount
    individualsCount
  }
}
    `;
export const useGetReportCountQuery = <
      TData = GetReportCountQuery,
      TError = unknown
    >(
      variables: GetReportCountQueryVariables,
      options?: UseQueryOptions<GetReportCountQuery, TError, TData>
    ) =>
    useQuery<GetReportCountQuery, TError, TData>(
      ['getReportCount', variables],
      fetchData<GetReportCountQuery, GetReportCountQueryVariables>(GetReportCountDocument, variables),
      options
    );
export const EditSettingsDocument = `
    mutation editSettings($input: EditSettingsInput!) {
  editSettings(input: $input) {
    setting {
      isKnownIndividualsEnabled
      activityEditDelayDays
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useEditSettingsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditSettingsMutation, TError, EditSettingsMutationVariables, TContext>) =>
    useMutation<EditSettingsMutation, TError, EditSettingsMutationVariables, TContext>(
      ['editSettings'],
      (variables?: EditSettingsMutationVariables) => fetchData<EditSettingsMutation, EditSettingsMutationVariables>(EditSettingsDocument, variables)(),
      options
    );
export const GetSettingsDocument = `
    query getSettings {
  settings {
    isKnownIndividualsEnabled
    isDistributionEnabled
    isInterventionEnabled
    isMeetingEnabled
    isPresentationEnabled
    isRoutineEnabled
    activityEditDelayDays
    fiscalYearStart
  }
}
    `;
export const useGetSettingsQuery = <
      TData = GetSettingsQuery,
      TError = unknown
    >(
      variables?: GetSettingsQueryVariables,
      options?: UseQueryOptions<GetSettingsQuery, TError, TData>
    ) =>
    useQuery<GetSettingsQuery, TError, TData>(
      variables === undefined ? ['getSettings'] : ['getSettings', variables],
      fetchData<GetSettingsQuery, GetSettingsQueryVariables>(GetSettingsDocument, variables),
      options
    );
export const AddTeamDocument = `
    mutation addTeam($input: AddTeamInput!) {
  addTeam(input: $input) {
    team {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useAddTeamMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddTeamMutation, TError, AddTeamMutationVariables, TContext>) =>
    useMutation<AddTeamMutation, TError, AddTeamMutationVariables, TContext>(
      ['addTeam'],
      (variables?: AddTeamMutationVariables) => fetchData<AddTeamMutation, AddTeamMutationVariables>(AddTeamDocument, variables)(),
      options
    );
export const AddTeamMembersDocument = `
    mutation addTeamMembers($input: AddTeamMembersInput!) {
  addTeamMembers(input: $input) {
    team {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useAddTeamMembersMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddTeamMembersMutation, TError, AddTeamMembersMutationVariables, TContext>) =>
    useMutation<AddTeamMembersMutation, TError, AddTeamMembersMutationVariables, TContext>(
      ['addTeamMembers'],
      (variables?: AddTeamMembersMutationVariables) => fetchData<AddTeamMembersMutation, AddTeamMembersMutationVariables>(AddTeamMembersDocument, variables)(),
      options
    );
export const DeleteTeamDocument = `
    mutation deleteTeam($input: DeleteTeamInput!) {
  deleteTeam(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useDeleteTeamMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteTeamMutation, TError, DeleteTeamMutationVariables, TContext>) =>
    useMutation<DeleteTeamMutation, TError, DeleteTeamMutationVariables, TContext>(
      ['deleteTeam'],
      (variables?: DeleteTeamMutationVariables) => fetchData<DeleteTeamMutation, DeleteTeamMutationVariables>(DeleteTeamDocument, variables)(),
      options
    );
export const EditTeamDocument = `
    mutation editTeam($input: EditTeamInput!) {
  editTeam(input: $input) {
    team {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useEditTeamMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditTeamMutation, TError, EditTeamMutationVariables, TContext>) =>
    useMutation<EditTeamMutation, TError, EditTeamMutationVariables, TContext>(
      ['editTeam'],
      (variables?: EditTeamMutationVariables) => fetchData<EditTeamMutation, EditTeamMutationVariables>(EditTeamDocument, variables)(),
      options
    );
export const RemoveTeamMemberDocument = `
    mutation removeTeamMember($input: RemoveTeamMemberInput!) {
  removeTeamMember(input: $input) {
    team {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useRemoveTeamMemberMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTeamMemberMutation, TError, RemoveTeamMemberMutationVariables, TContext>) =>
    useMutation<RemoveTeamMemberMutation, TError, RemoveTeamMemberMutationVariables, TContext>(
      ['removeTeamMember'],
      (variables?: RemoveTeamMemberMutationVariables) => fetchData<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>(RemoveTeamMemberDocument, variables)(),
      options
    );
export const FindTeamsDocument = `
    query findTeams($filter: TeamFilterInput) {
  teams(where: $filter) {
    id
    name
    description
    members {
      id
      displayName
      firstName
      lastName
      status
    }
  }
}
    `;
export const useFindTeamsQuery = <
      TData = FindTeamsQuery,
      TError = unknown
    >(
      variables?: FindTeamsQueryVariables,
      options?: UseQueryOptions<FindTeamsQuery, TError, TData>
    ) =>
    useQuery<FindTeamsQuery, TError, TData>(
      variables === undefined ? ['findTeams'] : ['findTeams', variables],
      fetchData<FindTeamsQuery, FindTeamsQueryVariables>(FindTeamsDocument, variables),
      options
    );
export const GetTeamByIdDocument = `
    query getTeamById($teamId: Int!) {
  teams(where: {id: {eq: $teamId}}) {
    id
    name
    description
    isDefault
    members {
      id
      firstName
      lastName
      displayName
      email
      status
      roles {
        name
        normalizedName
      }
      teams {
        id
        description
        name
      }
    }
  }
}
    `;
export const useGetTeamByIdQuery = <
      TData = GetTeamByIdQuery,
      TError = unknown
    >(
      variables: GetTeamByIdQueryVariables,
      options?: UseQueryOptions<GetTeamByIdQuery, TError, TData>
    ) =>
    useQuery<GetTeamByIdQuery, TError, TData>(
      ['getTeamById', variables],
      fetchData<GetTeamByIdQuery, GetTeamByIdQueryVariables>(GetTeamByIdDocument, variables),
      options
    );
export const DeactivateUserDocument = `
    mutation deactivateUser($input: DeactivateUserInput!) {
  deactivateUser(input: $input) {
    string
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useDeactivateUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeactivateUserMutation, TError, DeactivateUserMutationVariables, TContext>) =>
    useMutation<DeactivateUserMutation, TError, DeactivateUserMutationVariables, TContext>(
      ['deactivateUser'],
      (variables?: DeactivateUserMutationVariables) => fetchData<DeactivateUserMutation, DeactivateUserMutationVariables>(DeactivateUserDocument, variables)(),
      options
    );
export const EditUserDetailsDocument = `
    mutation editUserDetails($input: EditUserDetailsInput!) {
  editUserDetails(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useEditUserDetailsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditUserDetailsMutation, TError, EditUserDetailsMutationVariables, TContext>) =>
    useMutation<EditUserDetailsMutation, TError, EditUserDetailsMutationVariables, TContext>(
      ['editUserDetails'],
      (variables?: EditUserDetailsMutationVariables) => fetchData<EditUserDetailsMutation, EditUserDetailsMutationVariables>(EditUserDetailsDocument, variables)(),
      options
    );
export const InviteUserDocument = `
    mutation inviteUser($input: InviteUserInput!, $tenantId: String) {
  inviteUser(input: $input, tenantId: $tenantId) {
    applicationUser {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useInviteUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<InviteUserMutation, TError, InviteUserMutationVariables, TContext>) =>
    useMutation<InviteUserMutation, TError, InviteUserMutationVariables, TContext>(
      ['inviteUser'],
      (variables?: InviteUserMutationVariables) => fetchData<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, variables)(),
      options
    );
export const ModifyUserTeamsDocument = `
    mutation modifyUserTeams($input: ModifyUserTeamsInput!) {
  modifyUserTeams(input: $input) {
    applicationUser {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useModifyUserTeamsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ModifyUserTeamsMutation, TError, ModifyUserTeamsMutationVariables, TContext>) =>
    useMutation<ModifyUserTeamsMutation, TError, ModifyUserTeamsMutationVariables, TContext>(
      ['modifyUserTeams'],
      (variables?: ModifyUserTeamsMutationVariables) => fetchData<ModifyUserTeamsMutation, ModifyUserTeamsMutationVariables>(ModifyUserTeamsDocument, variables)(),
      options
    );
export const UpdateRoleDocument = `
    mutation updateRole($input: UpdateUserRoleInput!) {
  updateUserRole(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;
export const useUpdateRoleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateRoleMutation, TError, UpdateRoleMutationVariables, TContext>) =>
    useMutation<UpdateRoleMutation, TError, UpdateRoleMutationVariables, TContext>(
      ['updateRole'],
      (variables?: UpdateRoleMutationVariables) => fetchData<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument, variables)(),
      options
    );
export const FindAllUsersDocument = `
    query findAllUsers($filter: ApplicationUserFilterInput) {
  users(where: $filter) {
    id
    firstName
    lastName
    displayName
    email
  }
}
    `;
export const useFindAllUsersQuery = <
      TData = FindAllUsersQuery,
      TError = unknown
    >(
      variables?: FindAllUsersQueryVariables,
      options?: UseQueryOptions<FindAllUsersQuery, TError, TData>
    ) =>
    useQuery<FindAllUsersQuery, TError, TData>(
      variables === undefined ? ['findAllUsers'] : ['findAllUsers', variables],
      fetchData<FindAllUsersQuery, FindAllUsersQueryVariables>(FindAllUsersDocument, variables),
      options
    );
export const FindUsersDocument = `
    query findUsers($filter: ApplicationUserFilterInput) {
  activeUsers(where: $filter) {
    id
    firstName
    lastName
    displayName
    email
    status
    roles {
      name
      normalizedName
    }
    teams {
      id
      name
      description
      isDefault
    }
  }
}
    `;
export const useFindUsersQuery = <
      TData = FindUsersQuery,
      TError = unknown
    >(
      variables?: FindUsersQueryVariables,
      options?: UseQueryOptions<FindUsersQuery, TError, TData>
    ) =>
    useQuery<FindUsersQuery, TError, TData>(
      variables === undefined ? ['findUsers'] : ['findUsers', variables],
      fetchData<FindUsersQuery, FindUsersQueryVariables>(FindUsersDocument, variables),
      options
    );
export const FindUsersByTenantDocument = `
    query findUsersByTenant($tenantId: String!, $filter: ApplicationUserFilterInput) {
  usersByTenant(tenantId: $tenantId, where: $filter) {
    id
    firstName
    lastName
    displayName
    status
    roles {
      name
      normalizedName
    }
    teams {
      id
      name
      description
      isDefault
    }
  }
}
    `;
export const useFindUsersByTenantQuery = <
      TData = FindUsersByTenantQuery,
      TError = unknown
    >(
      variables: FindUsersByTenantQueryVariables,
      options?: UseQueryOptions<FindUsersByTenantQuery, TError, TData>
    ) =>
    useQuery<FindUsersByTenantQuery, TError, TData>(
      ['findUsersByTenant', variables],
      fetchData<FindUsersByTenantQuery, FindUsersByTenantQueryVariables>(FindUsersByTenantDocument, variables),
      options
    );
export const GetUserByIdDocument = `
    query getUserById($userId: String!) {
  activeUsers(where: {id: {eq: $userId}}) {
    id
    firstName
    lastName
    displayName
    status
    email
    roles {
      name
      normalizedName
    }
    teams {
      id
      name
      description
      isDefault
    }
  }
}
    `;
export const useGetUserByIdQuery = <
      TData = GetUserByIdQuery,
      TError = unknown
    >(
      variables: GetUserByIdQueryVariables,
      options?: UseQueryOptions<GetUserByIdQuery, TError, TData>
    ) =>
    useQuery<GetUserByIdQuery, TError, TData>(
      ['getUserById', variables],
      fetchData<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, variables),
      options
    );